(function () {
  'use strict';

  angular
    .module('psCheckout2', [
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngMaterial',
      'ui.mask',
      'angularPayments',
      'angular.css.injector'
    ]);

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckMfaSelections", psEcheckMfaSelections);

  /** @ngInject */
  function psEcheckMfaSelections() {
    var directive = {
      "scope": {
        "challengeIndex": "@"
      },
      "restrict": "EA",
      "controller": MfaSelectionsController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/mfa/selections/ps-echeck-mfa-selections.html"
    };

    return directive;

    /** @ngInject */
    function MfaSelectionsController($scope, psEcheckService, psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return psEcheckService.mfa.answers[vm.challengeIndex];
      }, answerChanged, true);

      ////////////////

      /**
       * Answer changed
       * @param answer
       */
      function answerChanged(answer) {
        switch(psEcheckService.mfa.challenges[vm.challengeIndex].id){

          // Name on Account
          case "ab216526d11f439686454029e5fd0d3a":
            psCheckoutService.updateState("echeck.name", answer);
            psEcheckService.mfa.nameOnAccount = answer;
            break;

          // Account Type
          case "46efd85404604e7c872b053daf5969ab":
            psCheckoutService.updateState("echeck.accountType", answer);
            psEcheckService.mfa.accountType = answer;
            break;

        }
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckMfaQuestions", psEcheckMfaQuestions);

  /** @ngInject */
  function psEcheckMfaQuestions() {
    var directive = {
      "scope": {
        "challengeIndex": "@"
      },
      "restrict": "EA",
      "controller": MfaQuestionsController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/mfa/questions/ps-echeck-mfa-questions.html"
    };

    return directive;

    /** @ngInject */
    function MfaQuestionsController($scope, psEcheckService, psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return psEcheckService.mfa.answers[vm.challengeIndex];
      }, answerChanged, true);

      ////////////////

      /**
       * Answer changed
       * @param answer
       */
      function answerChanged(answer) {
        switch(psEcheckService.mfa.challenges[vm.challengeIndex].id){

          // Name on Account
          case "ab216526d11f439686454029e5fd0d3a":
            psCheckoutService.updateState("echeck.name", answer);
            psEcheckService.mfa.nameOnAccount = answer;
            break;

          // Account Type
          case "46efd85404604e7c872b053daf5969ab":
            psCheckoutService.updateState("echeck.accountType", answer);
            psEcheckService.mfa.accountType = answer;
            break;

        }
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckMfaDevice", psEcheckMfaDevice);

  /** @ngInject */
  function psEcheckMfaDevice() {
    var directive = {
      "scope": {
        "challengeIndex": "@"
      },
      "restrict": "EA",
      "controller": MfaDeviceController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/mfa/device/ps-echeck-mfa-device.html"
    };

    return directive;

    /** @ngInject */
    function MfaDeviceController($scope, psEcheckService, psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return psEcheckService.mfa.answers[vm.challengeIndex];
      }, answerChanged, true);

      ////////////////

      /**
       * Answer changed
       * @param answer
       */
      function answerChanged(answer) {
        switch(psEcheckService.mfa.challenges[vm.challengeIndex].id){

          // Name on Account
          case "ab216526d11f439686454029e5fd0d3a":
            psCheckoutService.updateState("echeck.name", answer);
            psEcheckService.mfa.nameOnAccount = answer;
            break;

          // Account Type
          case "46efd85404604e7c872b053daf5969ab":
            psCheckoutService.updateState("echeck.accountType", answer);
            psEcheckService.mfa.accountType = answer;
            break;

        }
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckMfaButton", psEcheckMfaButton);

  /** @ngInject */
  function psEcheckMfaButton() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckMfaButtonController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/mfa/button/ps-echeck-mfa-button.html"
    };

    return directive;

    /** @ngInject */
    function EcheckMfaButtonController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckLoginUsername", psEcheckLoginUsername);

  /** @ngInject */
  function psEcheckLoginUsername() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckLoginUsernameController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/login/username/ps-echeck-login-username.html"
    };

    return directive;

    /** @ngInject */
    function EcheckLoginUsernameController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckLoginPin", psEcheckLoginPin);

  /** @ngInject */
  function psEcheckLoginPin() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckLoginPinController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/login/pin/ps-echeck-login-pin.html"
    };

    return directive;

    /** @ngInject */
    function EcheckLoginPinController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckLoginPassword", psEcheckLoginPassword);

  /** @ngInject */
  function psEcheckLoginPassword() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckLoginPasswordController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/login/password/ps-echeck-login-password.html"
    };

    return directive;

    /** @ngInject */
    function EcheckLoginPasswordController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckLoginButton", psEcheckLoginButton);

  /** @ngInject */
  function psEcheckLoginButton() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckLoginButtonController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/login/button/ps-echeck-login-button.html"
    };

    return directive;

    /** @ngInject */
    function EcheckLoginButtonController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckBanksSelect", psEcheckBanksSelect);

  /** @ngInject */
  function psEcheckBanksSelect() {
    var directive = {
      "scope": {
        "psBindings": "="
      },
      "restrict": "EA",
      "controller": EcheckBanksSelectController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/banks/select/ps-echeck-banks-select.html"
    };

    return directive;

    /** @ngInject */
    function EcheckBanksSelectController($scope, _, psEcheckService, psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService,
        "state" : psCheckoutService.getState()
      });

      $scope.$watch(function(){
        return _.get(vm, "service.banks.selectedBank.bankName");
      }, bankChanged);

      ////////////////

      /**
       * Bank changed
       * @param bankName
       */
      function bankChanged(bankName) {
        var sameName = _.get(vm, "service.banks.searchText") == _.get(vm, "service.banks.selectedBank.bankName");
        var notEmpty = !(_.isEmpty(bankName) || bankName == "");
        vm.service.banks.showSelectButton = notEmpty && sameName;
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckBanksLogos", psEcheckBanksLogos);

  /** @ngInject */
  function psEcheckBanksLogos() {
    var directive = {
      "scope": {
        "psBindings": "="
      },
      "restrict": "EA",
      "controller": EcheckBanksSelectController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/banks/logos/ps-echeck-banks-logos.html"
    };

    return directive;

    /** @ngInject */
    function EcheckBanksSelectController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });


      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckBanksButton", psEcheckBanksButton);

  /** @ngInject */
  function psEcheckBanksButton() {
    var directive = {
      "scope": {
        "psBindings": "="
      },
      "restrict": "EA",
      "controller": EcheckBanksButtonController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/banks/button/ps-echeck-banks-button.html"
    };

    return directive;

    /** @ngInject */
    function EcheckBanksButtonController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////


    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckAccountsSelect", psEcheckAccountsSelect);

  /** @ngInject */
  function psEcheckAccountsSelect() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckAccountsSelectController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/accounts/select/ps-echeck-accounts-select.html"
    };

    return directive;

    /** @ngInject */
    function EcheckAccountsSelectController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////
      
    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckAccountsButton", psEcheckAccountsButton);

  /** @ngInject */
  function psEcheckAccountsButton() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckAccountsButtonController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/accounts/button/ps-echeck-accounts-button.html"
    };

    return directive;

    /** @ngInject */
    function EcheckAccountsButtonController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psScheduledPaymentWizard", psScheduledPaymentWizard);

  /** @ngInject */
  function psScheduledPaymentWizard() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": ScheduledPaymentWizardController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-scheduled-payment/wizard/ps-scheduled-payment-wizard.html"
    };

    return directive;

    /** @ngInject */
    function ScheduledPaymentWizardController(psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService
      });

      ////////////////


    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckWizard", psEcheckWizard);

  /** @ngInject */
  function psEcheckWizard() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckWizardController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/wizard/ps-echeck-wizard.html"
    };

    return directive;

    /** @ngInject */
    function EcheckWizardController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService,
        "noLogo": noLogo
      });

      ////////////////

      /**
       * No logo
       * @returns {boolean}
       */
      function noLogo() {
        var selectedBank = _.get(psEcheckService, 'banks.selectedBank');
        var bankList =[];
        _.each(psEcheckService.banks.bankList, function(bank){
          bankList.push(_.get(bank, 'bankKey'));
        });
        return !_.includes(bankList, _.get(selectedBank, 'bankKey'));
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckSelected", psEcheckSelected);

  /** @ngInject */
  function psEcheckSelected() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckSelectedController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/selected/ps-echeck-selected.html"
    };

    return directive;

    /** @ngInject */
    function EcheckSelectedController($scope, psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService,
        "noLogo": noLogo
      });

      $scope.$watch(function () {
        return _.get(vm, "service.accounts.token");
      }, setBank, true);

      ////////////////

      /**
       * Format account
       * @param token
       */
      function setBank(token) {
        vm.bank = _.get(token, 'bank');
      }

      /**
       * No logo
       * @returns {boolean}
       */
      function noLogo() {
        var selectedBank = _.get(psEcheckService, 'banks.selectedBank');
        var bankList =[];
        _.each(psEcheckService.banks.bankList, function(bank){
          bankList.push(_.get(bank, 'bankKey'));
        });
        return !_.includes(bankList, _.get(selectedBank, 'bankKey'));
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckMfa", psEcheckMfa);

  /** @ngInject */
  function psEcheckMfa() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": MfaController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/mfa/ps-echeck-mfa.html",
    };

    return directive;

    /** @ngInject */
    function MfaController($scope, _, psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return _.get(vm, "service.mfa.data");
      }, mfaChanged, true);

      ////////////////

      /**
       * Mfa changed
       * @param data
       */
      function mfaChanged(data){
        /**
         * challenges: [
         *   {
         *     "answers": ["tomato", "potato"],
         *     "question": "You say tomato, I say...?",
         *     "type": "selections"
         *   },
         *   {
         *     "question": "Ketchup or mustard?",
         *     "type": "questions"
         *   },
         *   {
         *     "question": "Device sent to t...t@plaid.com",
         *     "type": "device"
         *   }
         * ]
         */
        vm.service.mfa.mfaForm = $scope.mfaForm;
        vm.service.mfa.mfaForm.$setUntouched();
        vm.service.mfa.mfaForm.$setPristine();
        vm.service.mfa.challenges.length = 0;
        _.merge(vm.service.mfa.challenges, data.challenges);
        vm.service.mfa.answers = [];
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckLogin", psEcheckLogin);

  /** @ngInject */
  function psEcheckLogin() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckLoginController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/login/ps-echeck-login.html"
    };

    return directive;

    /** @ngInject */
    function EcheckLoginController($scope, psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return $scope.loginForm;
      }, updateLoginForm, true);

      ////////////////

      /**
       * Update login form
       * @param newValue
       * @param oldValue
       */
      function updateLoginForm(newValue, oldValue){
        if (newValue != oldValue) {
          psEcheckService.login.loginForm = newValue;
        }
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckBanks", psEcheckBanks);

  /** @ngInject */
  function psEcheckBanks() {
    var directive = {
      "scope": {
        "psForm": "="
      },
      "restrict": "EA",
      "controller": EcheckBanksController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/banks/ps-echeck-banks.html"
    };

    return directive;

    /** @ngInject */
    function EcheckBanksController($scope, psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return $scope.banksForm;
      }, updateBanksForm, true);

      ////////////////

      /**
       * Update banks form
       * @param newValue
       */
      function updateBanksForm(newValue){
        psEcheckService.banks.banksForm = newValue;
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheckAccounts", psEcheckAccounts);

  /** @ngInject */
  function psEcheckAccounts() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckAccountsController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/accounts/ps-echeck-accounts.html"
    };

    return directive;

    /** @ngInject */
    function EcheckAccountsController($scope, psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      $scope.$watch(function () {
        return $scope.accountsForm;
      }, updateAccountsForm, true);

      ////////////////

      /**
       * Update login form
       * @param newValue
       */
      function updateAccountsForm(newValue) {
        psEcheckService.accounts.accountsForm = newValue;
      }

    }

  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psCardVerification", psCardVerification);

  /** @ngInject */
  function psCardVerification() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-card/verification/ps-card-verification.html",
      "scope": {},
      "controller": psCardVerificationController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psCardVerificationController(psCardService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCardService
      });

      ///////////////

    }
  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psCardNumber", psCardNumber);

  /** @ngInject */
  function psCardNumber() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-card/number/ps-card-number.html",
      "scope": {},
      "controller": psCardNumberController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psCardNumberController(psCardService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCardService
      });

      ///////////////

    }
  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psCardName", psCardName);

  /** @ngInject */
  function psCardName() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-card/name/ps-card-name.html",
      "scope": {},
      "controller": psCardNameController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psCardNameController(psCardService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCardService
      });

      ///////////////

    }
  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psCardExpiry", psCardExpiry);

  /** @ngInject */
  function psCardExpiry() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-card/expiry/ps-card-expiry.html",
      "scope": {},
      "controller": psCardExpiryController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psCardExpiryController(psCardService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCardService
      });

      ///////////////
      
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddressSubdivision", psAddressSubdivision);

  /** @ngInject */
  function psAddressSubdivision() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/subdivision/ps-address-subdivision.html",
      "scope": {
        "purpose": "@"
      },
      "controller": psAddressSubdivisionController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psAddressSubdivisionController(_, psCheckoutService, psIso3361Service, $scope) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "nothingFoundMessage": null,
        "address": psCheckoutService.getState(vm.purpose),
        "updateSubdivision": updateSubdivision,
        "searchOptions": searchOptions,
        "updateCountry": updateCountry,
        "onOptionSelected": onOptionSelected,
        "fieldName": vm.purpose + "_subdivision"
      });

      updateCountry(_.get(vm.address, "countryCode"), true);
      updateSubdivision(_.get(vm.address, "subdivisionCode"));

      $scope.$watch(function () {
          return _.get(vm, "address.subdivisionCode");
        },
        function (newVal) {
          vm.updateSubdivision(newVal);
        });
      $scope.$watch(function () {
          return _.get(vm, "address.countryCode");
        },
        function (newVal) {
          vm.updateCountry(newVal);
        });

      ////////////////

      /**
       * Update subdivision
       * @param newDivCode
       */
      function updateSubdivision(newDivCode) {
        if (vm.address.country) {
          if (newDivCode) {
            vm.address.subdivisionCode = newDivCode;
          }
          if (vm.address.subdivisionCode) {
            vm.address.subdivision =
              psIso3361Service.findSubdivisionByCode(vm.address.country, vm.address.subdivisionCode);
            if (vm.address.subdivision) {
              vm.address.subdivisionName = vm.address.subdivision.name
            }
            else {
              vm.address.subdivisionName = vm.address.subdivisionCode = null;
            }
          }
        }
        else {
          vm.address.subdivisionCode = newDivCode;
        }

        var formField = _.get(vm, "service.psForm["+vm.fieldName+"]");
        if (formField) {
          formField.$setValidity("notfound", !!vm.address.subdivisionCode);
        }

      }

      /**
       * Search options
       * @param searchText
       * @returns {*}
       */
      function searchOptions(searchText) {
        return psIso3361Service.searchSubdivisionByName(vm.address.country, searchText);
      }

      /**
       * Update country
       * @param newCountryCode
       * @param leaveState
       */
      function updateCountry(newCountryCode, leaveState) {
        if (!vm.address.country) {
          // Initialize country in case the country control hasn"t done so already (e.g. init)
          vm.address.countryCode = newCountryCode;
          vm.address.country = psIso3361Service.findCountryByCode(vm.address.countryCode);
          vm.address.countryName = _.get(vm.address.country, "name", "");
        }

        vm.nothingFoundMessage = (!vm.address.country) ? "Select country first" : null;

        if (!leaveState) {
          vm.updateSubdivision(null);
        }
      }

      /**
       * On option selected
       * @param subdivision
       */
      function onOptionSelected(subdivision) {
        vm.address.subdivisionCode = psIso3361Service.getSubdivisionCode(vm.address.country, subdivision);
        vm.updateSubdivision(vm.address.subdivisionCode);
      }

    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddressStreet", psAddressStreet);

  /** @ngInject */
  function psAddressStreet() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/street/ps-address-street.html",
      "scope": {
        "purpose": "@"
      },
      "controller": psAddressStreetController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    ///** @ngInject */
    function psAddressStreetController(psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "fieldName": vm.purpose + "_street",
        "address": psCheckoutService.getState(vm.purpose)
      });

      ////////////////

    }
  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddressPostal", psAddressPostal);

  /** @ngInject */
  function psAddressPostal() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/postal/ps-address-postal.html",
      "scope": {
        "purpose": "@"
      },
      "controller": psAddressPostalController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    ///** @ngInject */
    function psAddressPostalController(psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "fieldName": vm.purpose + "_postal",
        "address": psCheckoutService.getState(vm.purpose)
      });

      ////////////////

    }
  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEmail", psEmail);

  /** @ngInject */
  function psEmail() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/email/ps-email.html",
      "scope": {},
      "controller": psEmailController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psEmailController(psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "fieldName": "customer_email",
        "payer": psCheckoutService.getState("payer")
      });

      ////////////////
      
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddressCountry", psAddressCountry);

  /** @ngInject */
  function psAddressCountry() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/country/ps-address-country.html",
      "scope": {
        "purpose": "@"
      },
      "controller": psAddressCountryController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    ///** @ngInject */
    function psAddressCountryController(_, psCheckoutService, psIso3361Service, $scope) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "address": psCheckoutService.getState(vm.purpose),
        "searchOptions": searchOptions,
        "updateCountry": updateCountry,
        "onOptionSelected": onOptionSelected,
        "fieldName": vm.purpose + "_country"
      });

      updateCountry(vm.address.countryCode);

      $scope.$watch(function () {
          return vm.address.countryCode;
        },
        function (newVal) {
          vm.updateCountry(newVal);
        });

      ////////////////

      /**
       * Search options
       * @param searchText
       * @returns {Array}
       */
      function searchOptions(searchText) {
        return psIso3361Service.searchCountryByName(searchText);
      };

      /**
       * Update country
       * @param newCountryCode
       */
      function updateCountry(newCountryCode) {
        vm.address.countryCode = newCountryCode;
        vm.address.country = psIso3361Service.findCountryByCode(vm.address.countryCode);
        vm.address.countryName = _.get(vm.address.country, "name", "");
        var formField = _.get(vm, "service.psForm["+vm.fieldName+"]");
        if (formField) {
          formField.$setValidity("notfound", !!vm.address.country);
        }
      };

      /**
       * On option selected
       * @param country
       */
      function onOptionSelected(country) {
        var countryCode = country ? psIso3361Service.findCountryCode3byCode2(country.code) : "";
        updateCountry(countryCode);
      };

    }

  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddressCity", psAddressCity);

  /** @ngInject */
  function psAddressCity() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/city/ps-address-city.html",
      "scope": {
        "purpose": "@"
      },
      "controller": psAddressCityController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    ///** @ngInject */
    function psAddressCityController(psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "fieldName": vm.purpose + "_city",
        "address": psCheckoutService.getState(vm.purpose)
      });

      ////////////////
      
    }
  }

})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psBillingAddress", psBillingAddress);

  /** @ngInject */
  function psBillingAddress() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/billing/ps-billing-address.html",
      "scope": {}
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psTokenService', psTokenService);

  /** @ngInject */
  function psTokenService($log, $http, psCheckoutService, psMaps, psMapFilter, psAlertService, psEcheckService, psBankLoginService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "tokenize": tokenize,
        "urlVersion": "v3"
      }
    });

    return vm.service;

    /**
     * Make a payment
     */
    function tokenize() {
      var paymentType = psCheckoutService.getState("payment.type");
      if (paymentType == 'card') {
        return tokenizeCard();
      }
      if (paymentType == 'echeck') {
        return bankToken();
      }
    }

    /**
     * Tokenize card
     * @returns {*}
     */
    function tokenizeCard() {
      var request = psMapFilter(psCheckoutService.getState(), psMaps.tokenize.card);
      psCheckoutService.updateState("updateLock", true);
      return $http.post(psCheckoutService.getUrl("tokens"), request, getHeaders())
        .then(function (response) {
          $log.debug("tokenize card response:", response);
          var token = response.data;
          addSource(token);
          psAlertService.info("Card Save Success");
          psCheckoutService.updateState("Token", token);
          psCheckoutService.updateState("updateLock", false);
        })
        .catch(function (error) {
          psAlertService.error(psAlertService.getError(error.data));
          psCheckoutService.updateState("Token.status", "failed");
          psCheckoutService.updateState("updateLock", false);
        });
    }

    /**
     * Return selected bank token information
     */
    function bankToken() {
      var request = psMapFilter(psCheckoutService.getState(), psMaps.tokenize.echeck);
      psCheckoutService.updateState("updateLock", true);
      return psBankLoginService.convertToken(_.pick(psCheckoutService.getState(), [
        "tokenId"
      ]), request)
        .then(function (response) {
          $log.debug("tokenize bank response:", response);
          var token = response.token;
          addSource(token);
          psAlertService.info("Bank Save Success");
          psCheckoutService.updateState("Token", token);
          psCheckoutService.updateState("updateLock", false);
        })
        .catch(function (error) {
          psAlertService.error(psAlertService.getError(error.data));
          psCheckoutService.updateState("Token.status", "failed");
          psCheckoutService.updateState("updateLock", false);
        });
    }

    /**
     * Add source to token response
     * @param token
     * @returns {*}
     */
    function addSource(token) {
      var paymentType = psCheckoutService.getState("payment.type");
      var sourceType = paymentType == 'echeck' ? 'bank' : paymentType;
      _.set(token, 'source', _.get(token, sourceType));
      _.set(token, 'sourceId', _.get(token, sourceType + '.id'));
      _.set(token, 'sourceType', _.startCase(sourceType));
      return token;
    }

    /**
     * Get headers
     * @returns {{}}
     */
    function getHeaders() {
      return {
        "headers": {
          "X-PUBLISHABLE-KEY": psCheckoutService.getState("publishableKey")
        }
      };
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psThemeService', psThemeService);

  /** @ngInject */
  function psThemeService(cssInjector, _, themeService, $mdTheming, psCheckoutService, $log) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "getLayout": getLayout,
        "getTheme": getTheme,
        "setupMdTheme": setupMdTheme,
        "addExternalCss": addExternalCss,
        "addGoogleFont": addGoogleFont,
        "defaults": {
          "layout": "two-col",
          "theme": "classic"
        },
        "layouts": [
          "compact",
          "two-col",
          "backwards",
          "mini",
          "one-col",
          "stacked"
        ],
        "themes": [
          "classic",
          "material",
          "oneup",
          "darcula"
        ],
        "colors": [
          "red",
          "pink",
          "purple",
          "deep-purple",
          "indigo",
          "blue",
          "light-blue",
          "cyan",
          "teal",
          "green",
          "light-green",
          "lime",
          "yellow",
          "amber",
          "orange",
          "deep-orange",
          "brown",
          "grey",
          "blue-grey"
        ],
        "paletteTypes": [
          "primary",
          "accent",
          "warn"
        ]
      }
    });

    return vm.service;

    /**
     * Set md theme
     */
    function setupMdTheme() {
      var state = psCheckoutService.getState() || {};
      vm.theme = _.includes(vm.service.themes, state.theme) ? state.theme : vm.service.defaults.theme;
      if (state.palette) {
        createCustomTheme(state.palette);
        vm.theme = 'custom';
      }
      themeService.setDefaultTheme(vm.theme);
      //console.log("theme details:", _.get(themeService, "_THEMES[" + vm.theme + "].colors"));
    }

    /**
     * Get layout
     * @param layout
     */
    function getLayout(layout) {
      return _.includes(vm.service.layouts, layout) ? layout : vm.service.defaults.layout;
    }

    /**
     * Get theme
     * @param theme
     */
    function getTheme(theme) {
      return _.includes(vm.service.themes, theme) ? theme : vm.service.defaults.theme;
    }

    /**
     * Add external css file
     */
    function addExternalCss() {
      var css = psCheckoutService.getState('css');
      if (css) {
        cssInjector.add(css);
      }
    }

    /**
     * Add google font
     */
    function addGoogleFont() {
      var font = psCheckoutService.getState('font');
      if (font) {
        cssInjector.add("https://fonts.googleapis.com/css?family=" + font);
      }
    }

    /**
     * Create custom palette
     * @param data.primary
     * @param data.pink
     * @param data.warn
     */
    function createCustomTheme(data) {
      _.forEach(vm.service.paletteTypes, function (paletteType) {
        setPalette(data[paletteType], paletteType);
      });
      $mdTheming.generateTheme('custom');
    }

    /**
     * Set palette
     * @param data
     * @param type
     */
    function setPalette(data, type) {
      if (!data) {
        data = {};
        var colors = _.get(themeService, "_THEMES[" + vm.theme + "].colors[" + type + "]");
        _.set(data, _.get(colors, 'name'), _.get(colors, 'hues'));
      }
      if (_.isString(data)) {
        setCustomPalette(type, data);
      }
      else if (_.isObject(data)) {
        var color = _.head(_.keys(data));
        setCustomPalette(type, color, data[color]);
      }
    }

    /**
     * Set custom palette properties
     * @param type
     * @param color
     * @param hues
     */
    function setCustomPalette(type, color, hues) {
      if (!_.includes(vm.service.colors, color)) {
        $log.error("Error: ", type, "color must be one of", vm.service.colors);
      }
      else {
        var themeFunction = _.get(themeService.theme('custom'), type + 'Palette');
        if (_.isFunction(themeFunction)) {
          themeFunction(color, hues);
        }
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psScheduledPaymentService', psScheduledPaymentService);

  /** @ngInject */
  function psScheduledPaymentService($log, $http, psCheckoutService, psMaps, psMapFilter, psAlertService, moment) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "schedule": schedule,
        "urlVersion": "v3"
      }
    });

    return vm.service;

    /**
     * Make a payment
     */
    function schedule() {
      $log.debug("scheduled payment request:", getRequest());
      psCheckoutService.updateState("updateLock", true);
      var paymentType = psCheckoutService.getState("payment.type");
      switch (paymentType) {
        case "card":
          return $http.post(psCheckoutService.getUrl("scheduledPaymentGroups/public"), getCardRequest(), getHeaders())
            .then(function (response) {
              psAlertService.info("Schedule Payment Success");
              $log.debug("schedule payment response:", response.data);
              psCheckoutService.updateState("ScheduledPayment", response.data);
              psCheckoutService.updateState("updateLock", false);
            })
            .catch(function (error) {
              psAlertService.error(psAlertService.getError(error.data));
              psCheckoutService.updateState("Payment.status", "failed");
              psCheckoutService.updateState("updateLock", false);
            });
          break;
        case "echeck":
          var request = getEcheckRequest();
          var bankSessionRequest = {
            "billingAddress": request.scheduledPayments[0].payer.address,
            "payer": request.scheduledPayments[0].payer
          };
          var token = _.pick(psCheckoutService.getState(), ["tokenId"]);
          return $http.put(psCheckoutService.getUrl("bankSessionTokens/" + token.tokenId + "/convert/public"), bankSessionRequest, getHeaders())
            .then(function (tokenized) {
              $log.debug("token :", tokenized.data);
              request.scheduledPayments[0].tokenId = tokenized.data.token.id;
              if(_.get(tokenized, "data.token.payerId")) {
                request.scheduledPayments[0] = _.omit(request.scheduledPayments[0], "payer");
                request.scheduledPayments[0].payerId = tokenized.data.token.payerId; 
              }
              return $http.post(psCheckoutService.getUrl("scheduledPaymentGroups/public"), request, getHeaders())
                .then(function (response) {
                  psAlertService.info("Schedule Payment Success");
                  $log.debug("schedule payment response:", response.data);
                  psCheckoutService.updateState("ScheduledPayment", response.data);
                  psCheckoutService.updateState("updateLock", false);
                })
                .catch(function (error) {
                  psAlertService.error(psAlertService.getError(error.data));
                  psCheckoutService.updateState("ScheduledPayment.status", "failed");
                  psCheckoutService.updateState("updateLock", false);
                });
            })
            .catch(function (error) {
              psAlertService.error(psAlertService.getError(error.data));
              psCheckoutService.updateState("Token.status", "failed");
              psCheckoutService.updateState("updateLock", false);
            });
          break;
      }
    }

    /**
     * Get headers
     * @returns {{}}
     */
    function getHeaders() {
      return {
        "headers": {
          "X-PUBLISHABLE-KEY": psCheckoutService.getState("publishableKey")
        }
      };
    }

    /**
     * Get request
     */
    function getRequest() {
      var request;
      var paymentType = psCheckoutService.getState("payment.type");
      switch (paymentType) {
        case "card":
          request = getCardRequest();
          break;
        case "echeck":
          request = getEcheckRequest();
          break;
      }
      return request;
    }

    /**
     * Get address request
     */
    function getCardRequest() {
      var data = psCheckoutService.getState();
      var request = psMapFilter(data, psMaps.scheduledPayment.card);
      var mappedItems = mapScheduledItems(request);
      _.set(request, 'scheduledPayments', mappedItems);
      return request;
    }

    /**
     * Get echeck request
     * @returns {*}
     */
    function getEcheckRequest() {
      var data = psCheckoutService.getState();
      var request = psMapFilter(data, psMaps.scheduledPayment.echeck);
      var mappedItems = mapScheduledItems(request);
      _.set(request, 'scheduledPayments', mappedItems);
      return request;
    }

    /**
     * Map scheduled items
     * @param request
     */
    function mapScheduledItems(request) {
      var scheduledItems = _.get(request, 'scheduledPayments');
      var mappedItems = [];
      _.each(scheduledItems, function (item) {
        mappedItems.push(psMapFilter(item, psMaps.scheduledItem));
      });
      return mappedItems;
    }

  }

})
();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psScheduledPayment', psScheduledPayment);

  /** @ngInject */
  function psScheduledPayment() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-scheduled-payment/ps-scheduled-payment.html",
      "scope": {},
      "controller": psScheduledPaymentController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psScheduledPaymentController(psCheckoutService, $scope) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "scheduledPayment": {},
        "show": [],
        "toggle": toggle
      });

      $scope.$watch(getScheduledPayment, refreshScheduledPaymentInfo);

      /**
       * Refresh scheduled payment info
       */
      function refreshScheduledPaymentInfo() {
        vm.scheduledPayment = getScheduledPayment();
      }

      /**
       * Get scheduled payment
       * @param path
       * @returns {*}
       */
      function getScheduledPayment(path) {
        var scheduledPayment = psCheckoutService.getState('scheduledPayment');
        return !path ? scheduledPayment : _.get(scheduledPayment, path);
      }

      /**
       * Toggle
       * @param index
       */
      function toggle(index) {
        var toggleTo = !vm.show[index];
        if (toggleTo) {
          _.fill(vm.show, false);
        }
        vm.show[index] = toggleTo;
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psReceiptToken', psReceiptToken);

  /** @ngInject */
  function psReceiptToken() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-receipt-token/ps-receipt-token.html",
      "scope": {},
      "controller": psReceiptPaymentController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psReceiptPaymentController() {

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psReceiptScheduledPayment', psReceiptScheduledPayment);

  /** @ngInject */
  function psReceiptScheduledPayment() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-receipt-scheduled-payment/ps-receipt-scheduled-payment.html",
      "scope": {},
      "controller": psReceiptScheduledPaymentController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psReceiptScheduledPaymentController() {

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psReceiptPayment', psReceiptPayment);

  /** @ngInject */
  function psReceiptPayment() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-receipt-payment/ps-receipt-payment.html",
      "scope": {},
      "controller": psReceiptPaymentController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psReceiptPaymentController() {

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psReceipt', psReceipt);

  /** @ngInject */
  function psReceipt() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-receipt/ps-receipt.html",
      "scope": {
        "receipt": "@"
      },
      "controller": psReceiptController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psReceiptController() {
      var vm = this;

      angular.extend(vm, {
        "isReceiptType": isReceiptType
      });

      /**
       * Is this the receipt type
       * @returns {boolean}
       */
      function isReceiptType(type) {
        return vm.receipt == type;
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psPaymentService', psPaymentService);

  /** @ngInject */
  function psPaymentService($log, $http, psCheckoutService, psMaps, psMapFilter, psAlertService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "pay": pay,
        "urlVersion": "v3"
      }
    });

    return vm.service;

    /**
     * Make a payment
     */
    function pay() {
      $log.debug("payment request");
      psCheckoutService.updateState("updateLock", true);

      var paymentType = psCheckoutService.getState("payment.type");
      console.log("paymentType", paymentType);
      switch (paymentType) {
        case "card":
          return $http.post(psCheckoutService.getUrl("payments"), getCardRequest(), getHeaders())
            .then(function (response) {
              psAlertService.info("Payment Success");
              $log.debug("payment response:", response.data);
              psCheckoutService.updateState("Payment", response.data);
              psCheckoutService.updateState("updateLock", false);
            })
            .catch(function (error) {
              psAlertService.error(psAlertService.getError(error.data));
              psCheckoutService.updateState("Payment.status", "failed");
              psCheckoutService.updateState("updateLock", false);
            });
          break;
        case "echeck":
          var request = getEcheckRequest();
          var bankSessionRequest = {
            "billingAddress": request.payer.address,
            "payer": request.payer
          };
          var token = _.pick(psCheckoutService.getState(), ["tokenId"]);
          return $http.put(psCheckoutService.getUrl("bankSessionTokens/" + token.tokenId + "/convert/public"), bankSessionRequest, getHeaders())
            .then(function (tokenized) {
              $log.debug("token :", tokenized.data);
              request.tokenId = tokenized.data.token.id;
              if(_.get(tokenized, "data.token.payerId")) {
                request = _.omit(request, "payer");
                request.payerId = tokenized.data.token.payerId;
              }
              request.payerId = tokenized.data.token.payerId;
              return $http.post(psCheckoutService.getUrl("payments"), request, getHeaders())
                .then(function (response) {
                  psAlertService.info("Payment Success");
                  $log.debug("payment response:", response.data);
                  psCheckoutService.updateState("Payment", response.data);
                  psCheckoutService.updateState("updateLock", false);
                })
                .catch(function (error) {
                  psAlertService.error(psAlertService.getError(error.data));
                  psCheckoutService.updateState("Payment.status", "failed");
                  psCheckoutService.updateState("updateLock", false);
                });
            })
            .catch(function (error) {
              psAlertService.error(psAlertService.getError(error.data));
              psCheckoutService.updateState("Token.status", "failed");
              psCheckoutService.updateState("updateLock", false);
            });
          break;
      }
    }

    /**
     * Get headers
     * @returns {{}}
     */
    function getHeaders() {
      return {
        "headers": {
          "X-PUBLISHABLE-KEY": psCheckoutService.getState("publishableKey")
        }
      };
    }

    /**
     * Get address request
     */
    function getCardRequest() {
      return psMapFilter(psCheckoutService.getState(), psMaps.card);
    }

    /**
     * Get echeck request
     * @returns {*}
     */
    function getEcheckRequest() {
      return psMapFilter(psCheckoutService.getState(), psMaps.echeck);
    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psPayButton", psPayButton);

  /** @ngInject */
  function psPayButton() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-pay-button/ps-pay-button.html",
      "replace": false,
      "scope": {},
      "controller": psPayButtonController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psPayButtonController(psCheckoutService, psPaymentService, psScheduledPaymentService, psTokenService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "state" : psCheckoutService.getState(),
        "pay": pay
      });

      ////////////////

      /**
       * Pay
       * @returns {*}
       */
      function pay() {
        var checkoutType = _.get(vm, 'service.checkoutType');
        var method;
        switch(checkoutType) {
          case 'scheduled':
            method = psScheduledPaymentService.schedule;
            break;
          case 'payment':
            method = psPaymentService.pay;
            break;
          case 'tokenize':
            method = psTokenService.tokenize;
        }
        return method();
      }
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .filter("psMap", psMap);

  /** @ngInject */
  function psMap(_) {

    return mapData;
    
    ////////////////

    /**
     * Map or whitelist data according map passed in
     * @param data
     * @param map
     */
    function mapData(data, map) {
      var mappedData = {};

      var whitelist = _.get(map, "whitelist");
      if (whitelist) {
        _.each(whitelist, function (key) {
          if (hasValue(data, key)) {
            _.set(mappedData, key, _.get(data, key));
          }
        });
      }

      var subMap = _.get(map, "map");
      if (subMap) {
        _.forEach(subMap, function (value, key) {
          if (hasValue(data, key)) {
            if (_.isArray(value)) {
              _.each(value, function (path) {
                _.set(mappedData, path, _.get(data, key));
              });
            }
            else {
              _.set(mappedData, value, _.get(data, key));
            }
          }
        });
      }

      return mappedData;
    }

    /**
     * Does this key contain meaningful data
     * @param data
     * @param key
     * @returns {boolean}
     */
    function hasValue(data, key){
      return (!_.isEmpty(_.get(data, key)) && !_.isNull(_.get(data, key))) || _.isBoolean(_.get(data, key)) || _.isEqual([], _.get(data, key));
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLogo', psLogo);

  /** @ngInject */
  function psLogo() {
    var directive = {
      "restrict": "E",
      "replace": true,
      "templateUrl": "app/components/ps-checkout/ps-logo/ps-logo.html",
      "scope": {},
      "controller": psLogoController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLogoController($scope, psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "logoUrl": null,
        "logoWidth": null,
        "logoHeight": null
      });

      $scope.$watch(getLogo, setUrl);

      /**
       * Set url after config has been received
       */
      function setUrl() {
        var logo = psCheckoutService.getState('logo') || {};
        vm.logoUrl = logo.url;
        vm.logoHeight = logo.height;
        vm.logoWidth = logo.width;
      }

      /**
       * Get logo
       */
      function getLogo() {
        return psCheckoutService.getState('logo');
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .factory('psIso3361Service', psIso3361Service);

  /** @ngInject */
  function psIso3361Service(_, $window) {

    var iso3166 = $window.iso3166;

    var vm = this;

    angular.extend(vm, {
      "service": {
        searchCountryByName: searchCountryByName,
        findCountryByCode: findCountryByCode,
        findCountryCode3byCode2: findCountryCode3byCode2,
        findCountryCode2byCode3: findCountryCode2byCode3,
        findSubdivisionByCode: findSubdivisionByCode,
        searchSubdivisionByName: searchSubdivisionByName,
        getSubdivisionCode: getSubdivisionCode
      }
    });

    return vm.service;

    /**
     * Search for country which name starts with searchText
     * @param searchText
     * @returns {Array}
     */
    function searchCountryByName(searchText) {
      searchText = (searchText) ? searchText.toLowerCase() : null;
      return _.sortBy(
        _.pick(iso3166.data,
          function (c, k) {
            c.code = k;
            if (!searchText) {
              return c;
            }
            else {
              return _.startsWith(c.name.toLowerCase(), searchText);
            }
          }),
        'name'
      );
    }

    /**
     * Find country by its ISO 3361 alpha-2 or alpha-3 code
     * @param code
     * @returns {null}
     */
    function findCountryByCode(code) {
      var country = code ? $window.iso3166.country(code) : null;
      return !_.isEmpty(country) ? country : null;
    }

    /**
     * Find country ISO 3361 alpha-3 code by alpha-2 code
     * @param code2
     */
    function findCountryCode3byCode2(code2) {
      code2 = (code2) ? code2.toUpperCase() : null;
      return _.findKey($window.iso3166.codes, function (m) {
        return m === code2;
      });
    }

    /**
     * Find country ISO 3361 alpha-2 code by alpha-3 code
     * @param code3
     */
    function findCountryCode2byCode3(code3) {
      code3 = (code3) ? code3.toUpperCase() : null;
      return $window.iso3166.codes[code3];
    }

    /**
     * Find subdivision in specified country by its code
     * @param country
     * @param code
     * @returns {*}
     */
    function findSubdivisionByCode(country, code) {
      if (country && code) {
        return _.get(country, 'sub.' + country.code + '-' + code, null);
      }
      return null;
    }

    /**
     * Search for subdivision in country which name starts with searchText
     * @param country
     * @param searchText
     * @returns {*}
     */
    function searchSubdivisionByName(country, searchText) {
      if (country) {
        searchText = (searchText) ? searchText.toLowerCase() : null;
        //$log.debug("psIso3361Service.searchCountryByName(" + searchText + ")");
        return _.sortBy(
          _.pick(country.sub,
            function (v, k) {
              v.code = k;
              if (!searchText) {
                return true; // No searchText means everything is a match
              }
              else {
                return _.startsWith(v.name.toLowerCase(), searchText);
              }
            }),
          'name'
        );
      }
      return false;
    }

    /**
     * Get the letter code for the subdivision
     * @param country
     * @param subdivision
     * @returns {*}
     */
    function getSubdivisionCode(country, subdivision) {
      if (subdivision && (subdivision.code || (searchSubdivisionByName(country, subdivision.name)))) {
        // If code has not been initialized yet, use country and name to find and hence initialize it
        return subdivision.code.slice(3);
      }
      else {
        return "";
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutTwoCol', psLayoutTwoCol);

  /** @ngInject */
  function psLayoutTwoCol() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-two-col.html",
      "scope": {},
      "controller": psLayoutTwoColController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutTwoColController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutStacked', psLayoutStacked);

  /** @ngInject */
  function psLayoutStacked() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-stacked.html",
      "scope": {},
      "controller": psLayoutStackedController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutStackedController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutOneCol', psLayoutOneCol);

  /** @ngInject */
  function psLayoutOneCol() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-one-col.html",
      "scope": {},
      "controller": psLayoutOneColController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutOneColController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutMini', psLayoutMini);

  /** @ngInject */
  function psLayoutMini() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-mini.html",
      "scope": {},
      "controller": psLayoutMiniController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutMiniController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutCompact', psLayoutCompact);

  /** @ngInject */
  function psLayoutCompact() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-compact.html",
      "scope": {},
      "controller": psLayoutCompactController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutCompactController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psLayoutBackwards', psLayoutBackwards);

  /** @ngInject */
  function psLayoutBackwards() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-layout/ps-layout-backwards.html",
      "scope": {},
      "controller": psLayoutBackwardsController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psLayoutBackwardsController(psCheckoutService) {
      var vm = this;
      angular.extend(vm, {
        "service": psCheckoutService
      });
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psInvalid", psInvalid);

  /** @ngInject */
  function psInvalid() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": InvalidController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-invalid/ps-invalid.html"
    };

    return directive;

    /** @ngInject */
    function InvalidController() {

      ////////////////

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .filter('psToJson', psToJson);

  /** @ngInject */
  function psToJson() {
    return function (value) {
      return angular.toJson(value, 2);
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .filter('psToNumber', psToNumber);

  /** @ngInject */
  function psToNumber() {
    return function (value) {
      console.log(value);
      console.log(parseInt(value));
      return parseInt(value);
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .filter('psStartCase', psStartCase);

  /** @ngInject */
  function psStartCase() {
    return function (value) {
      return _.startCase(value);
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psExternal', psExternal);

  /** @ngInject */
  function psExternal(psCheckoutService, $window, $rootScope, psMapFilter, psConfigMap, $log, psThemeService, _) {

    var vm = this;

    vm.state = psCheckoutService.getState();

    angular.extend(vm, {
      "service": {
        "initialize": initialize,
        "received": false
      },
      "receiveConfig": receiveConfig,
      "watchPayment": watchPayment,
      "reactToPaymentStatus": reactToPaymentStatus,
      "postMessage": postMessage
    });

    return vm.service;

    ////////////////

    /**
     * Initialize
     */
    function initialize() {
      $window.addEventListener("message", receiveConfig, false);
      $window.parent.postMessage("sendConfiguration", "*");
      watchPayment();
      watchScheduledPayment();
      watchToken();
    }

    /**
     * Init iFrame
     * @param request
     */
    function receiveConfig(request) {
      vm.service.received = false;
      var config = _.get(request, 'data');
      var version = _.get(config, 'version');
      $log.log("version:", version);
      var isCurrentVersion = version == _.get(psCheckoutService, 'currentVersion') || !version;
      $log.log("is current version?", isCurrentVersion);
      if (version == '2.0') {
        mapFeatures(config);
      }
      vm.config = isCurrentVersion ? config : psMapFilter(config, _.get(psConfigMap, version));
      mergeMeta(vm.config);
      vm.config = psMapFilter(vm.config, psConfigMap['3.0']);
      mapScheduledItems(vm.config);
      addDefaults(vm.config);
      psCheckoutService.loadConfig(vm.config);
      vm.service.received = true;
    }

    /**
     * Default layout and themes
     * @param config
     */
    function addDefaults(config) {
      config = config || {};
      config.layout = psThemeService.getLayout(config.layout);
      config.theme = psThemeService.getTheme(config.theme);
    }

    /**
     * Map scheduled items
     * @param config
     */
    function mapScheduledItems(config) {
      if (!_.isEmpty(_.get(config, "scheduledPayment.scheduledItems"))) {
        var items = config.scheduledPayment.scheduledItems;
        _.forEach(items, function (scheduledItem, scheduledItemKey) {
          items[scheduledItemKey] = psMapFilter(scheduledItem, psConfigMap['3.0']['scheduledItem']);
        });
        config.scheduledPayment.scheduledItems = items;
      }
    }

    /**
     * Merge meta
     * @param config
     */
    function mergeMeta(config) {
      if (!_.isEmpty(_.get(config, "meta")) && !_.isEmpty(_.get(config, "z"))) {
        config.z = _.merge(config.meta, config.z);
      }
    }

    /**
     * Map features from 2.0 hash to paymentMethods array
     * @param config
     */
    function mapFeatures(config) {
      var paymentMethods = [];
      var features = _.get(config, 'features');
      if (_.get(features, 'echeck.enabled')) {
        paymentMethods.push('echeck')
      }
      if (_.get(features, 'card')) {
        paymentMethods.push('card')
      }
      config.paymentMethods = paymentMethods;
    }

    /**
     * Watch the payment object and listen for config
     */
    function watchPayment() {
      $rootScope.$watchCollection(
        function () {
          return psCheckoutService.getState("Payment");
        },
        function (newValue) {
          return reactToPaymentStatus(newValue);
        });
    }

    /**
     * Watch the scheduled payment object and listen for config
     */
    function watchScheduledPayment() {
      $rootScope.$watchCollection(
        function () {
          return psCheckoutService.getState("ScheduledPayment");
        },
        function (newValue) {
          return reactToScheduledPaymentStatus(newValue);
        });
    }

    /**
     * Watch the token object and listen for config
     */
    function watchToken() {
      $rootScope.$watchCollection(
        function () {
          return psCheckoutService.getState("Token");
        },
        function (newValue) {
          return reactToTokenStatus(newValue);
        });
    }

    /**
     * Check the payment status
     * @param payment
     * @returns {*}
     */
    function reactToPaymentStatus(payment) {
      var type;
      switch (_.get(payment, 'status')) {
        case "posted":
        case "processing":
          type = "checkoutComplete";
          break;
        case "failed":
          type = "checkoutFailed";
          break;
        case "update":
        default:
          type = null;
      }
      return type ? postMessage(type, payment) : false;
    }

    /**
     * Check the scheduled payments group status
     * @param scheduledPayment
     * @returns {*}
     */
    function reactToScheduledPaymentStatus(scheduledPayment) {
      var type;
      if (_.get(scheduledPayment, 'status') == 'active') {
        type = "checkoutComplete";
      }
      else if (_.get(scheduledPayment, 'status') == 'failed') {
        type = "checkoutFailed";
      }
      return type ? postMessage(type, scheduledPayment) : false;
    }

    /**
     * Check the token status
     * @param token
     * @returns {*}
     */
    function reactToTokenStatus(token) {
      var type;
      if (_.get(token, 'status') == 'active') {
        type = "checkoutComplete";
      }
      else if (_.get(token, 'status') == 'failed') {
        type = "checkoutFailed";
      }
      return type ? postMessage(type, token) : false;
    }

    /**
     * Post message
     * @param type
     * @param response
     */
    function postMessage(type, response) {
      if (type == 'checkoutComplete') {
        psCheckoutService.updateState('checkoutComplete', true);
      }
      $window.parent.postMessage({
        "type": type,
        "response": response
      }, "*");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .constant('psConfigMap', {
      "3.0": {
        "whitelist": [
          "customer.email",
          "payer.name",
          "payer.email",
          "version",
          "publishableKey",
          "checkoutDomain",
          "domain",
          "storeUrl",
          "theme",
          "layout",
          "css",
          "palette",
          "font",
          "logo",
          "payment.amount",
          "currency",
          "details.shipping",
          "details.subtotal",
          "details.tax",
          "details.service",
          "details.processing",
          "features",
          "billing.street",
          "billing.city",
          "billing.subdivisionCode",
          "billing.countryCode",
          "billing.postalCode",
          "shipping.street",
          "shipping.city",
          "shipping.subdivisionCode",
          "shipping.countryCode",
          "shipping.postalCode",
          "payment.amount",
          "paymentMethods",
          "card.number",
          "card.securityCode",
          "scheduledPayment.name",
          "scheduledPayment.description",
          "scheduledPayment.scheduledItems",
          "demo",
          "meta"
        ],
        "map": {
          "customer.email": "payer.email",
          "y.n": "payer.name",
          "payer.name": ["echeck.name", "card.name"],
          "y.e": "payer.email",
          "v": "version",
          "k": "publishableKey",
          "h": "checkoutDomain",
          "o": "domain",
          "u": "storeUrl",
          "t": "theme",
          "l": "layout",
          "w": "css",
          "a": "palette",
          "n": "font",
          "g": "logo",
          "p.a": "payment.amount",
          "c": "currency",
          "d.s": "details.shipping",
          "d.u": "details.subtotal",
          "d.t": "details.tax",
          "d.e": "details.service",
          "d.p": "details.processing",
          "f": "features",
          "b.s": "billing.street",
          "b.c": "billing.city",
          "b.d": "billing.subdivisionCode",
          "b.u": "billing.countryCode",
          "b.p": "billing.postalCode",
          "s.s": "shipping.street",
          "s.c": "shipping.city",
          "s.d": "shipping.subdivisionCode",
          "s.u": "shipping.countryCode",
          "s.p": "shipping.postalCode",
          "m": "paymentMethods",
          "i.n": "card.number",
          "i.s": "card.securityCode",
          "r.n": "scheduledPayment.name",
          "r.d": "scheduledPayment.description",
          "r.i": "scheduledPayment.scheduledItems",
          "e": "demo",
          "z": "meta"
        },
        "scheduledItem": {
          "whitelist": [
            "name",
            "description",
            "schedule",
            "amount"
          ],
          "map": {
            "n": "name",
            "d": "description",
            "s.n": "schedule.name",
            "s.d": "schedule.description",
            "s.i": "schedule.interval",
            "s.c": "schedule.intervalCount",
            "s.a": "schedule.anchor",
            "s.s": "schedule.dateStart",
            "s.t": "schedule.timesToRun",
            "a": "amount"
          }
        }
      },
      "2.0": {
        "map": {
          "version": "version",
          "publishableKey": "publishableKey",
          "checkout_domain": "checkoutDomain",
          "domain": "domain",
          "storeURL": "storeUrl",
          "template": "template",
          "layout": "layout",
          "theme": "theme",
          "css": "css",
          "palette": "palette",
          "font": "font",
          "logo": "logo",
          "total": "payment.amount",
          "currency": "payment.currency",
          "details": "details",
          "paymentMethods": "paymentMethods",
          "features.echeck.enabled": "features.echeck.login",
          "features.cards": "features.card",
          "features.bitcoin": "features.bitcoin",
          "ui.billing.show": "billing.show",
          "ui.billing.autoFill.email": "payer.email",
          "ui.billing.autoFill.fullName": "payer.name",
          "ui.billing.autoFill.street1": "billing.street",
          "ui.billing.autoFill.street2": "billing.street2",
          "ui.billing.autoFill.city": "billing.city",
          "ui.billing.autoFill.state": "billing.subdivisionCode",
          "ui.billing.autoFill.country": "billing.countryCode",
          "ui.billing.autoFill.postalCode": "billing.postalCode",
          "ui.shipping.show": "shipping.show",
          "ui.shipping.autoFill.email": "shipping.email",
          "ui.shipping.autoFill.fullName": "shipping.fullName",
          "ui.shipping.autoFill.street1": "shipping.street",
          "ui.shipping.autoFill.street2": "shipping.street2",
          "ui.shipping.autoFill.city": "shipping.city",
          "ui.shipping.autoFill.state": "shipping.subdivisionCode",
          "ui.shipping.autoFill.country": "shipping.countryCode",
          "ui.shipping.autoFill.postalCode": "shipping.postalCode",
          "ui.shipping.autoFill.sameAsBilling": "shipping.sameAsBilling",
          "ui.summary": "ui",
          "meta": "meta",
          "card.number": "card.number",
          "card.securityCode": "card.securityCode",
          "scheduledPayment": "scheduledPayment",
          "demo": "demo"
        }
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psEcheckService', psEcheckService);

  /** @ngInject */
  function psEcheckService($rootScope, _, $mdDialog, psBankLoginService, psCheckoutService, psAlertService, psBigJsService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "banks": {
          "selectBank": selectBank,
          "verifyBank": verifyBank,
          "openLogin": openLogin,
          "closeLogin": closeLogin,
          "setSelectedBank": setSelectedBank,
          "searchBanks": searchBanks,
          "selectOther": selectOther,
          "clearState": clearState,
          "resetState": resetState,
          "showSelect": showSelect,
          "hideSelect": hideSelect,
          "showLogos": showLogos,
          "hideLogos": hideLogos,
          "showButton": showButton,
          "hideButton": hideButton,
          "showSelectBank": showSelectBank,
          "showBankLogos": showBankLogos,
          "getClasses": getClasses,
          "banksForm": {},
          "selectedBank": null,
          "bankList": getBankList(),
          "buttonText": "Select",
          "searchText": "",
          "showSelectButton": false,
          "selectedSearchBank": null,
          "selectShow": true,
          "logosShow": true,
          "buttonShow": true
        },
        "wizard": {
          "showLogin": showLogin,
          "hideLogin": hideLogin,
          "showMfa": showMfa,
          "hideMfa": hideMfa,
          "showAccounts": showAccounts,
          "hideAccounts": hideAccounts,
          "clearWizard": clearWizard,
          "loginShow": true,
          "mfaShow": false,
          "accountsShow": false
        },
        "login": {
          "clearLogin": clearLogin,
          "login": login,
          "loginForm": {},
          "username": "",
          "password": "",
          "pin": ""
        },
        "mfa": {
          "submitMfa": submitMfa,
          "clearMfa": clearMfa,
          "mfaForm": {},
          "challenges": [],
          "answers": [],
          "data": {},
          "type": "",
          "accountType": "",
          "nameOnAccount": ""
        },
        "accounts": {
          "saveTokens": saveTokens,
          "clearAccounts": clearAccounts,
          "selectAccount": selectAccount,
          "accountsForm": {},
          "tokens": [],
          "token": null
        },
        "showBanks": showBanks,
        "hideBanks": hideBanks,
        "showSelectedBank": showSelectedBank,
        "hideSelectedBank": hideSelectedBank,
        "resetEcheck": resetEcheck,
        "banksShow": true,
        "selectedBankShow": false
      }
    });

    clearWizard();

    $rootScope.$watch(function () {
      return _.get(vm, "service.accounts.token.id");
    }, tokenChanged);

    return vm.service;

    ////////////////

    /**
     * Token changed
     * @param tokenId
     */
    function tokenChanged(tokenId) {
      psCheckoutService.updateState("tokenId", tokenId);
      psCheckoutService.updateState("payerName", _.get(vm, "service.accounts.token.nameOnAccount"));

    }

    /**
     * Reset echeck
     */
    function resetEcheck() {
      clearWizard();
      clearState();
      closeLogin();
      hideSelectedBank();
      showBanks();
    }

    /**
     * Select account
     */
    function selectAccount() {
      hideBanks();
      showSelectedBank();
      closeLogin();
      psCheckoutService.updateState('echeckBankSelected', true);
    }

    /**
     * Show selected bank
     */
    function showSelectedBank() {
      vm.service.selectedBankShow = true;
    }

    /**
     * Hide selected bank
     */
    function hideSelectedBank() {
      vm.service.selectedBankShow = false;
    }

    /**
     * Clear wizard
     */
    function clearWizard() {
      clearMfa();
      clearLogin();
      clearAccounts();
      hideAccounts();
      hideMfa();
      showLogin();
    }

    /**
     * Clear Accounts
     */
    function clearAccounts() {
      vm.service.accounts.accountsForm = {};
      vm.service.accounts.tokens = [];
      vm.service.accounts.token = null;
    }

    /**
     * Clear Mfa
     */
    function clearMfa() {
      vm.service.mfa.mfaForm = {};
      vm.service.mfa.answers = "";
      vm.service.mfa.data = null;
      vm.service.mfa.type = null;
    }

    /**
     * Submit mfa
     */
    function submitMfa() {
      vm.service.updateLock = true;
      return psBankLoginService.mfa(_.get(vm, "service.login.response.id"), vm.service.mfa.answers)
        .then(function (response) {
          vm.service.updateLock = false;
          vm.service.mfa.response = response;
          return loginResponse(response);
        })
        .catch(function (error) {
          vm.service.updateLock = false;
          psAlertService.error(psAlertService.getError(error.data));
        });
    }

    /**
     * Get credentials
     * @returns {{username: string, password: string, pin: string, bankKey: *}}
     */
    function getCredentials() {
      return {
        "username": vm.service.login.username,
        "password": vm.service.login.password,
        "pin": vm.service.login.pin,
        "bankKey": _.get(vm, "service.banks.selectedBank.bankKey")
      };
    }

    /**
     * Login
     */
    function login() {
      vm.service.updateLock = true;
      return psBankLoginService.login(getCredentials())
        .then(function (response) {
          vm.service.updateLock = false;
          vm.service.login.response = response;
          psCheckoutService.updateState("bankLogin", _.pick(response, ['id']));
          return loginResponse(response);
        })
        .catch(function (error) {
          vm.service.updateLock = false;
          psAlertService.error(psAlertService.getError(error.data));
        });
    }

    /**
     * Login response
     * @param response
     */
    function loginResponse(response) {
      if (_.get(response, 'status') === "mfa") {
        loadMfa(response.activeMfa);
        hideLogin();
        showMfa();
      }
      else {
        saveTokens(response);
        validateBanks();
        hideLogin();
        hideMfa();
        showAccounts();
      }
    }

    /**
     * Save tokens
     * @param tokens
     */
    function saveTokens(tokens) {
      vm.service.accounts.tokens = tokens;
    }

    /**
     * Process Banks (tokens) for validity
     */
    function validateBanks() {
      vm.service.accounts.token = null;
      var state = psCheckoutService.getState();
      _.forEach(vm.service.accounts.tokens, function (token) {
        var balance = _.get(token, "availableBalance");
        if(_.isNull(balance) || _.isUndefined(balance)) {
          _.set(token, "availableBalance", _.get(token, "currentBalance"));
        }
        token.bank = token.bank || {};
        var bank = token.bank;
        var availableBalance = _.get(token, 'availableBalance');
        bank.insufficientFunds = (psCheckoutService.checkoutType == 'payment') ?
          psBigJsService.lessThan(availableBalance, state.payment.amount) : false;
        bank.currencyDoesNotMatch = state.currency != token.currency;
        bank.invalid = bank.insufficientFunds || bank.currencyDoesNotMatch;
        if (!vm.service.accounts.token && !bank.invalid) {
          vm.service.accounts.token = token;
        }
      });
    }

    /**
     * Show banks
     */
    function showBanks() {
      vm.service.banksShow = true;
    }

    /**
     * Hide banks
     */
    function hideBanks() {
      vm.service.banksShow = false;
    }

    /**
     * Show Accounts
     */
    function showAccounts() {
      vm.service.wizard.accountsShow = true;
    }

    /**
     * Hide accounts
     */
    function hideAccounts() {
      vm.service.wizard.accountsShow = false;
    }

    /**
     * Load Mfa
     * @param mfaData
     */
    function loadMfa(mfaData) {
      vm.service.mfa.data = mfaData;
      vm.service.mfa.type = mfaData.type;
    }

    /**
     * Show mfa
     */
    function showMfa() {
      vm.service.wizard.mfaShow = true;
    }

    /**
     * Hide mfa
     */
    function hideMfa() {
      vm.service.wizard.mfaShow = false;
    }

    /**
     * Show Login
     */
    function showLogin() {
      vm.service.wizard.loginShow = true;
    }

    /**
     * Hide login
     */
    function hideLogin() {
      vm.service.wizard.loginShow = false;
    }

    /**
     *  Clear login form
     */
    function clearLogin() {
      vm.service.login.loginForm = {};
      vm.service.login.username = "";
      vm.service.login.password = "";
      vm.service.login.pin = "";
    }

    /**
     * Set selected bank
     * @param bank
     */
    function setSelectedBank(bank) {
      vm.service.banks.selectedBank = bank;
    }

    /**
     * Select bank
     * @param bank
     * @returns {*}
     */
    function selectBank(bank) {
      if (bank) {
        vm.service.banks.setSelectedBank(bank);
      }
      clearWizard();
      return verifyBank()
        .then(function () {
          openLogin();
        })
        .catch(function (error) {
          psAlertService.error(psAlertService.getError(error.data));
        });
    }

    /**
     * Verify bank
     * @returns {*}
     */
    function verifyBank() {
      var bankName = _.get(vm, "service.banks.selectedBank.bankName");
      var bankKey = _.get(vm, "service.banks.selectedBank.bankKey");
      return psBankLoginService.getBanks(bankName)
        .then(function (results) {
          var found = false;
          _.forEach(results, function (value) {
            if (value.bankKey == bankKey) {
              found = true;
            }
          })
          if (!found) {
            throw new Error();
          }
        });
    }

    /**
     * Open login
     */
    function openLogin() {
      $mdDialog.show({
        "templateUrl": "app/components/ps-checkout/ps-echeck/wizard/ps-echeck-wizard-modal.html",
        "parent": angular.element(document.body),
        "clickOutsideToClose": true,
        "openFrom": {
          "top": -50,
          "width": 30,
          "height": 80
        },
        "closeTo": {
          "left": 1500
        }
      });
    }

    /**
     * Close login
     */
    function closeLogin() {
      $mdDialog.hide();
    }

    /**
     * Reset the state
     */
    function resetState() {
      clearState();
      showBankLogos();
    }

    /**
     * Clear current state
     */
    function clearState() {
      vm.service.banks.selectedBank = null;
      vm.service.banks.selectedSearchBank = null;
    }

    /**
     * Show select Bank
     */
    function showSelectBank() {
      clearState();
      hideLogos();
      showButton();
      showSelect();
    }

    /**
     * Show banks logos
     */
    function showBankLogos() {
      clearState();
      clearWizard();
      hideSelectedBank();
      showSelect();
      showButton();
      showLogos()
    }

    /**
     * Show button
     */
    function showButton() {
      vm.service.banks.buttonShow = true;
    }

    /**
     * Hide buttons
     */
    function hideButton() {
      vm.service.banks.buttonShow = false;
    }

    /**
     * Show select
     */
    function showSelect() {
      vm.service.banks.selectShow = true;
    }

    /**
     * Hide select
     */
    function hideSelect() {
      vm.service.banks.selectShow = false;
    }

    /**
     * Show logos
     */
    function showLogos() {
      vm.service.banks.logosShow = true;
    }

    /**
     * Hide logos
     */
    function hideLogos() {
      vm.service.banks.logosShow = false;
    }

    /**
     * Search banks
     * @param search
     * @returns {*}
     */
    function searchBanks() {
      return psBankLoginService.getBanks(vm.service.banks.searchText);
    }

    /**
     * Select other bank
     */
    function selectOther() {
      showSelectBank();
    }

    /**
     * Get classes
     * @param bank
     */
    function getClasses(bank) {
      return "fa fa-" + bank.icon + " fa-ex";
    }

    /**
     * Get bank list
     * @returns {*[]}
     */
    function getBankList() {
      return [
        {
          "id": "9p2jd8y8w1mrnlijp5sqy1by",
          "bankName": "Bank of America",
          "bankKey": "bofa",
          "icon": "firefox",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "hl0xel07bkv4o8zgea8tij5q",
          "bankName": "Capital One",
          "bankKey": "capone",
          "icon": "facebook",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "lhcvr3hk8ndllujprt3q5k9i",
          "bankName": "Charles Schwab",
          "bankKey": "schwab",
          "icon": "drupal",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": false}
        }, {
          "id": "t0twp6bx87pvl2p5d7k4js3d",
          "bankName": "Chase",
          "bankKey": "chase",
          "icon": "digg",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "brrmnj39zwufiqmpbi6g9t9r",
          "bankName": "Citi",
          "bankKey": "citi",
          "icon": "apple",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "3hr7h5epmevjns1plctdyywp",
          "bankName": "Fidelity",
          "bankKey": "fidelity",
          "icon": "linux",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": false}
        }, {
          "id": "44xmqo6xq2eqj3ktyjsgwkpz",
          "bankName": "Navy Federal Credit Union",
          "bankKey": "nfcu",
          "icon": "html5",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": false}
        }, {
          "id": "5rv54vfge0p3qiyg4foijkp7",
          "bankName": "PNC",
          "bankKey": "pnc",
          "icon": "flickr",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "k00nh8yrgo8wjh9dtovtiwpj",
          "bankName": "SunTrust",
          "bankKey": "suntrust",
          "icon": "linkedin",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": false}
        }, {
          "id": "7ofa6ghek9uwiwnplczc3o6l",
          "bankName": "TD Bank",
          "bankKey": "td",
          "icon": "chrome",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "5y9wjc3fh943qhkabztwpzc0",
          "bankName": "US Bank",
          "bankKey": "us",
          "icon": "rebel",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": true}
        }, {
          "id": "0gmwgtbfx7u7innulegduntz",
          "bankName": "USAA",
          "bankKey": "usaa",
          "icon": "twitch",
          "required": {"username": true, "password": true, "pin": true, "accountNumber": false, "mfa": true}
        }, {
          "id": "y826qadbg0gtj32nqghodq2v",
          "bankName": "Wells Fargo",
          "bankKey": "wells",
          "icon": "twitter",
          "required": {"username": true, "password": true, "pin": false, "accountNumber": false, "mfa": false}
        }
      ];
    }

  }
})();

(function() {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psEcheck", psEcheck);

  /** @ngInject */
  function psEcheck() {
    var directive = {
      "scope": {},
      "restrict": "EA",
      "controller": EcheckController,
      "controllerAs": "vm",
      "bindToController": true,
      "templateUrl": "app/components/ps-checkout/ps-echeck/ps-echeck.html"
    };

    return directive;

    /** @ngInject */
    function EcheckController(psEcheckService) {

      var vm = this;

      angular.extend(vm, {
        "service": psEcheckService
      });

      ////////////////

    }
    
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psDemo', psDemo);

  /** @ngInject */
  function psDemo() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-demo/ps-demo.html",
      "scope": {},
      "controller": psDemoController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psDemoController(psCheckoutService, psThemeService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "themes": psThemeService.themes,
        "layouts": psThemeService.layouts,
        "colors": psThemeService.colors
      });

    }
  }

})();
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psCardService', psCardService);

  /** @ngInject */
  function psCardService($rootScope, moment, psCheckoutService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "card": psCheckoutService.getState("card"),
        "cardForm": {},
        "cardType": null,
        "cardExpiry": null
      }
    });

    $rootScope.$watch(function(){
      return vm.service.cardExpiry;
    }, expirationChanged);

    return vm.service;

    ////////////////

    /**
     * Expiration changed
     * @param newValue
     */
    function expirationChanged(newValue){
      if(newValue){
        psCheckoutService.updateState("card.expirationMonth", moment(newValue, "M/YYYY").format("MM"));
        psCheckoutService.updateState("card.expirationYear", moment(newValue, "M/YYYY").format("YYYY"));
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psCard', psCard);

  /** @ngInject */
  function psCard() {
    var directive = {
      "templateUrl": 'app/components/ps-checkout/ps-card/ps-card.html',
      "scope": {},
      "restrict": "EA",
      "controller": CardController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function CardController($scope, psCardService, psCheckoutService) {

      var vm = this;

      angular.extend(vm, {
        "service": psCardService,
        "isLayout": isLayout
      });

      $scope.$watch(function () {
        return $scope.cardForm;
      }, updateCardForm, true);

      ////////////////

      /**
       * Update card form
       * @param newValue
       */
      function updateCardForm(newValue) {
        if (newValue != psCardService.cardForm) {
          psCardService.cardForm = newValue;
        }
      }

      /**
       * Is layout
       * @param layouts
       * @returns {boolean}
       */
      function isLayout(layouts) {
        var isLayout = false;
        layouts = _.isString(layouts) ? [layouts] : layouts;
        _.each(layouts, function (layout) {
          if (layout == psCheckoutService.getState('layout')) {
            isLayout = true;
          }
        });
        return isLayout;
      }

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .filter('psCardTypeCSSClass', psCardTypeCSSClass);

  /** @ngInject */
  function psCardTypeCSSClass() {
    var filter = function (cardType) {
      var classString = "pf ";
      switch (cardType) {
        case "maestro":
          classString += "pf-maestro";
          break;
        case "dinersclub":
          classString += "pf-diners";
          break;
        case "jcb":
          classString += "pf-jcb";
          break;
        case "mastercard":
          classString += "pf-mastercard";
          break;
        case "unionpay":
          classString += "pf-unionpay";
          break;
        case "discover":
          classString += "pf-discover";
          break;
        case "amex":
          classString += "pf-american-express";
          break;
        case "visa":
          classString += "pf-visa";
          break;
        case "laser":
        default:
          classString = "";
      }
      return classString
    };
    return filter;
  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psBigJsService', psBigJsService);

  /** @ngInject */
  function psBigJsService(Big, _) {

    var service = {
      "round": round,
      "toDecimal": toDecimal,
      "toPennies": toPennies,
      "toDollars": toDollars,
      "subtract": subtract,
      "add": add,
      "multiply": multiply,
      "divide": divide,
      "equals": equals,
      "lessThan": lessThan,
      "lessThanEqual": lessThanEqual,
      "greaterThan": greaterThan,
      "greaterThanEqual": greaterThanEqual,
      "abs": abs,
      "modulus": modulus,
      "math": math
    };

    return service;

    /**
     * Round
     * @param amount
     * @param fixed
     * @returns {string|*}
     */
    function round(amount, fixed) {
      fixed = fixed || 0;
      var value = new Big(amount);
      return value.round(fixed, 1).toFixed();
    }

    /**
     * Convert to big js decimal
     * @param amount
     * @param fixed
     */
    function toDecimal(amount, fixed) {
      var value = new Big(amount);
      return value.round(fixed, 1).toFixed(fixed);
    }

    /**
     * To pennies
     * @param dollars
     */
    function toPennies(dollars) {
      return multiply(dollars, 100, 0);
    }

    /**
     * To dollars
     * @param pennies
     * @returns {string}
     */
    function toDollars(pennies) {
      return divide(pennies, 100, 2);
    }

    /**
     * Subtract
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function subtract(value1, value2, fixed) {
      return math("minus", value1, value2, fixed);
    }

    /**
     * Add
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function add(value1, value2, fixed) {
      return math("plus", value1, value2, fixed);
    }

    /**
     * Multiply
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function multiply(value1, value2, fixed) {
      return math("times", value1, value2, fixed);
    }

    /**
     * Divide
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function divide(value1, value2, fixed) {
      return math("div", value1, value2, fixed);
    }

    /**
     * Equals
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function equals(value1, value2, fixed) {
      return math("eq", value1, value2, fixed);
    }

    /**
     * Less than
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function lessThan(value1, value2, fixed) {
      return math("lt", value1, value2, fixed);
    }

    /**
     * Less than or equal to
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function lessThanEqual(value1, value2, fixed) {
      return math("lte", value1, value2, fixed);
    }

    /**
     * Greater than
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function greaterThan(value1, value2, fixed) {
      return math("gt", value1, value2, fixed);
    }

    /**
     * Greater than or equal to
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function greaterThanEqual(value1, value2, fixed) {
      return math("gte", value1, value2, fixed);
    }

    /**
     * Absolute value
     * @param value1
     * @param fixed
     * @returns {string}
     */
    function abs(value1, fixed) {
      fixed = fixed || 0;
      var v1 = new Big(value1);
      var answer = v1.abs();
      if (!_.isBoolean(answer)) {
        answer = answer.round(fixed, 1).toFixed(fixed);
      }
      return answer;
    }

    /**
     * Modulus
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function modulus(value1, value2, fixed) {
      return math("mod", value1, value2, fixed);
    }

    /**
     * Math
     * @param operation
     * @param value1
     * @param value2
     * @param fixed
     * @returns {string}
     */
    function math (operation, value1, value2, fixed) {
      fixed = fixed || 0;
      var v1 = new Big(value1 || 0);
      var answer = v1[operation](value2 || 0);
      if (!_.isBoolean(answer)) {
        answer = answer.round(fixed, 1).toFixed(fixed);
      }
      return answer;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psBankLoginService', psBankLoginService);

  /** @ngInject */
  function psBankLoginService($http, _, $log, psCheckoutService, psAlertService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "getBanks": getBanks,
        "login": login,
        "mfa": mfa,
        "getTokens": getTokens,
        "convertToken": convertToken
      }
    });

    return vm.service;

    /**
     * Get bank login banks
     * @param value
     * @returns {*}
     */
    function getBanks(value) {
      return $http.get(psCheckoutService.getUrl("bankSessionInstitutions/public"), getBankHeaders(value))
        .then(function (response) {
          $log.log("response:", response.data.results);
          return response.data.results;
        })
        .catch(function (error) {
          $log.log("error:", error);
          psAlertService.error(psAlertService.getError(error.data));
          throw error;
        });
    }

    /**
     * Get bank headers
     * @param value
     */
    function getBankHeaders(value) {
      var headers = {
        "headers": {
          "X-PUBLISHABLE-KEY": psCheckoutService.getState("publishableKey")
        },
        "params": {
          "filter": {
            "limit": 20
          }
        }
      };
      if (value) {
        _.merge(headers.params.filter, {
          "where": {
            "bankName": {
              "like": value + "%"
            }
          }
        });
      }
      return headers
    }

    /**
     * Login to bank
     * @returns {*}
     */
    function login(credentials) {
      return $http.post(psCheckoutService.getUrl("bankSessions/public"), credentials, getHeaders())
        .then(function (response) {
          $log.log(response.data);
          return getLoginResponse(response);
        })
        .catch(function (error) {
          $log.log(error.data);
          throw error;
        });
    }

    /**
     * Get login response
     * @param response
     * @returns {*}
     */
    function getLoginResponse(response) {
      if (_.get(response, 'data.status') === "verified") {
        return response.data.bankSessionTokens;
      }
      else if (_.get(response, 'data.status') === "mfa") {
        return response.data;
      }
      else {
        return response.data;
      }
    }

    /**
     * Get login headers
     * @returns {{}}
     */
    function getHeaders() {
      var headers = {
        "headers": {
          "X-PUBLISHABLE-KEY": psCheckoutService.getState("publishableKey")
        }
      };
      return headers
    }

    /**
     * Get bank login tokens
     */
    function getTokens(bankLoginId) {
      return $http.get(psCheckoutService.getUrl("banklogins/" + bankLoginId + "/tokens"), getHeaders())
        .then(function (tokens) {
          $log.log("tokens:", tokens.data);
          return tokens.data;
        })
        .catch(function (error) {
          $log.log(error.data);
          throw error;
        });
    }

    /**
     * Convert bank login token
     * @param account
     * @param data
     * @returns {*}
     */
    function convertToken(account, data) {
      var request = {
        "billingAddress": data.payer.address,
        "payer": data.payer
      };
      return $http.put(psCheckoutService.getUrl("bankSessionTokens/" + account.tokenId + "/convert/public"), request, getHeaders())
        .then(function (tokenized) {
          $log.log("token :", tokenized.data);
          return tokenized.data;
        })
        .catch(function (error) {
          $log.log(error.data);
          throw error;
        });
    }

    /**
     * Bank login mfa
     */
    function mfa(bankLoginId, answers) {
      return $http.put(psCheckoutService.getUrl("bankSessions/" + bankLoginId + "/public"), getMfaRequest(answers), getHeaders())
        .then(function (response) {
          $log.log("response:", response.data);
          return getLoginResponse(response);
        })
        .catch(function (error) {
          $log.log("error:", error.data);
          throw error;
        });
    }

    /**
     * Get mfa request
     * @param answers
     * @returns {{}}
     */
    function getMfaRequest(answers) {

      if (answers.length == 1) {
        answers = _.head(answers);
      }
      var request = {
        "mfaAnswer": answers
      };
      return request;
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .service("psAlertService", psAlertService);

  /** @ngInject */
  function psAlertService($mdToast) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "error": errorAlert,
        "info": infoAlert,
        "warning": warningAlert,
        "getError": getError
      }
    });

    return vm.service;

    ////////////////

    /**
     * Get error
     * @param error
     */
    function getError(error){
      var newError;
      var detailedExplanation = _.get(error, "error.details.explanation");
      detailedExplanation = _.isPlainObject(detailedExplanation) ? _.get(error, "details.description") : detailedExplanation;
      var detailedDescription = _.get(error, "error.details.description");
      var description = _.get(error, "error.description");
      var code = _.get(error, "error.details.code");
      if (code === "AUTHORIZATION_REQUIRED") {
        newError = "This merchant is not authorized by PayStand.";
      }
      else {
        newError = detailedExplanation || detailedDescription || description;
        newError = newError || "Oops! Something went wrong";
      }
      return newError;
    }

    /**
     * Error alert
     * @param message
     */
    function errorAlert(message) {
      $mdToast.show({
        templateUrl: "app/components/ps-checkout/ps-alert/ps-alert-error.html",
        position: "top right",
        controller: [function () {
          this.message = message;
          this.close = $mdToast.hide;
        }],
        controllerAs: "vm",
        // parent: "ps-alert",
        hideDelay: 0
      });
    }

    /**
     * Info alert
     * @param message
     * @returns {*}
     */
    function infoAlert(message) {
      $mdToast.show({
        templateUrl: "app/components/ps-checkout/ps-alert/ps-alert-info.html",
        position: "top right",
        controller: [function () {
          this.message = message;
        }],
        controllerAs: "vm",
        parent: "ps-alert"
      });
    }

    /**
     * Warning alert
     * @param message
     */
    function warningAlert(message) {
      $mdToast.show({
        templateUrl: "app/components/ps-checkout/ps-alert/ps-alert-warning.html",
        position: "top right",
        controller: [function () {
          this.message = message;
          this.close = $mdToast.hide;
        }],
        controllerAs: "vm"
      });
    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAlert", psAlert);

  /** @ngInject */
  function psAlert() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-alert/ps-alert.html",
      "scope": {},
      "controller": AlertController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function AlertController() {


    }

  }

})();

(function () {
  "use strict";

  angular
    .module("psCheckout2")
    .directive("psAddress", psAddress);

  /** @ngInject */
  function psAddress() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-address/ps-address.html",
      "scope": {
        "purpose": "@"
      }
    };

    return directive;
  }

})();

(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    "domain": "https://localhost:3001",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "pekbdvyho3o2jc0swym3jcqb",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    //"checkoutDomain": "http://localhost:3002/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    //"checkoutDomain": "http://localhost:3002/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "dswk9d1kloe9po35riuhgzyt", // Stripe
    //"publishableKey": "m08twybi12slq7o6priyae4z", // Vantiv
    // "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    "checkoutDomain": "http://localhost:3003/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    "domain": "https://localhost:3001",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    //"checkoutDomain": "http://localhost:3002/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    //"checkoutDomain": "http://localhost:3002/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "tt50f24wcl5yjxe566s8b26q",
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    "domain": "https://localhost:3001",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "unhtbyuv918fjljk7711ij4y",
    "publishableKey": "68bcte0wkelxqf5scs7tclkn", // lindy
    "checkoutDomain": "https://checkout.paystand.co/v3/",
    "domain": "https://api.paystand.co",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "03meucnwtw6fnbw1pvffvphx", // Stripe
    //"publishableKey": "m08twybi12slq7o6priyae4z", // Vantiv
    "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    //"checkoutDomain": "http://localhost:3002/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    // "publishableKey": "mu5r693slwpdk1nmr4vn985b",
    "publishableKey": "0yqowfwfxb2vpnuv9ovpqvgt",
    "checkoutDomain": "https://checkout.paystand.biz/v3/",
    "domain": "https://api.paystand.biz",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .constant('psMaps', {
      // Echeck payment request map
      "echeck": {
        "map": {
          "payment.amount": "amount",
          "currency": "currency",
          "description": "description",
          "meta": "meta",
          "billing.street": "payer.address.street1",
          "billing.city": "payer.address.city",
          "billing.subdivisionCode": "payer.address.state",
          "billing.postalCode": "payer.address.postalCode",
          "billing.countryCode": "payer.address.country",
          "payer.email": "payer.email",
          // "echeck.name": "payer.name",
          "payerName": "payer.name",
          "tokenId": "tokenId"
        }
      },
      // Card payment request map
      "card": {
        "map": {
          "payment.amount": "amount",
          "currency": "currency",
          "description": "description",
          "meta": "meta",
          "payer.email": "payer.email",
          "billing.street": ["payer.address.street1", "card.billingAddress.street1"],
          "billing.city": ["payer.address.city", "card.billingAddress.city"],
          "billing.subdivisionCode": ["payer.address.state", "card.billingAddress.state"],
          "billing.postalCode": ["payer.address.postalCode", "card.billingAddress.postalCode"],
          "billing.countryCode": ["payer.address.country", "card.billingAddress.country"],
          "card.name": [
            "payer.name",
            "card.nameOnCard"
          ],
          "card.number": "card.cardNumber",
          "card.expirationMonth": "card.expirationMonth",
          "card.expirationYear": "card.expirationYear",
          "card.securityCode": "card.securityCode"
        }
      },
      // Scheduled payments group request map earlier known as Schedule Payment
      "scheduledPayment": {
        "card": {
          "map": {
            "scheduledPayment.name": "name",
            "scheduledPayment.description": "description",
            "scheduledPayment.scheduledItems": "scheduledPayments",
            "card.name": ["scheduledPayments[0].payer.name", "scheduledPayments[0].card.nameOnCard"],
            "payer.email": "scheduledPayments[0].payer.email",
            "customer.name": "scheduledPayments[0].payer.name",
            "customer.email": "scheduledPayments[0].payer.email",
            "billing.street": ["scheduledPayments[0].payer.address.street1", "scheduledPayments[0].card.billingAddress.street1"],
            "billing.city": ["scheduledPayments[0].payer.address.city", "scheduledPayments[0].card.billingAddress.city"],
            "billing.subdivisionCode": ["scheduledPayments[0].payer.address.state", "scheduledPayments[0].card.billingAddress.state"],
            "billing.postalCode": ["scheduledPayments[0].payer.address.postalCode", "scheduledPayments[0].card.billingAddress.postalCode"],
            "billing.countryCode": ["scheduledPayments[0].payer.address.country", "scheduledPayments[0].card.billingAddress.country"],
            "tokenId": "scheduledPayments[0].tokenId",
            "cardId": "scheduledPayments[0].cardId",
            "payerId": "scheduledPayments[0].payerId",
            "description": "scheduledPayments[0].description",
            "meta": "scheduledPayments[0].meta",
            "currency": "scheduledPayments[0].currency",
            "card.number": "scheduledPayments[0].card.cardNumber",
            "card.expirationMonth": "scheduledPayments[0].card.expirationMonth",
            "card.expirationYear": "scheduledPayments[0].card.expirationYear",
            "card.securityCode": "scheduledPayments[0].card.securityCode"
          }
        },
        "echeck": {
          "map": {
            "scheduledPayment.name": "name",
            "scheduledPayment.description": "description",
            "scheduledPayment.scheduledItems": "scheduledPayments",
            "echeck.name": "scheduledPayments[0].payer.name",
            "payer.email": "scheduledPayments[0].payer.email",
            "customer.name": "scheduledPayments[0].payer.name",
            "customer.email": "scheduledPayments[0].payer.email",
            "billing.street": "scheduledPayments[0].payer.address.street1",
            "billing.city": "scheduledPayments[0].payer.address.city",
            "billing.subdivisionCode": "scheduledPayments[0].payer.address.state",
            "billing.postalCode": "scheduledPayments[0].payer.address.postalCode",
            "billing.countryCode": "scheduledPayments[0].payer.address.country",
            "tokenId": "scheduledPayments[0].tokenId",
            "bankId": "scheduledPayments[0].bankId",
            "payerId": "scheduledPayments[0].payerId",
            "description": "scheduledPayments[0].description",
            "meta": "scheduledPayments[0].meta",
            "currency": "scheduledPayments[0].currency"
          }
        }
      },
      // Scheduled item now known as Schedule Payment
      "scheduledItem": {
        "whitelist": [
          "name",
          "card",
          "bank",
          "payer",
          "tokenId",
          "cardId",
          "bankId",
          "description",
          "amount",
          "schedule",
          "meta"
        ],
        "map": {
          "paymentDetails.amount": "amount"
        }
      },
      // Tokenize card request map
      "tokenize": {
        "card": {
          "whitelist": [
            "card.securityCode",
            "card.expirationMonth",
            "card.expirationYear",
            "meta"
          ],
          "map": {
            "card.number": "card.cardNumber",
            "card.name": ["card.payer.name", "card.nameOnCard"],
            "payer.email": "card.payer.email",
            "billing.street": ["card.billingAddress.street1", "card.payer.address.street1"],
            "billing.city": ["card.billingAddress.city", "card.payer.address.city"],
            "billing.subdivisionCode": ["card.billingAddress.state", "card.payer.address.state"],
            "billing.postalCode": ["card.billingAddress.postalCode", "card.payer.address.postalCode"],
            "billing.countryCode": ["card.billingAddress.country", "card.payer.address.country"]
          }
        },
        "echeck": {
          "map": {
            "echeck.name": "payer.name",
            "payer.email": "payer.email",
            "customer.name": "payer.name",
            "customer.email": "payer.email",
            "billing.street": "payer.address.street1",
            "billing.city": "payer.address.city",
            "billing.subdivisionCode": "payer.address.state",
            "billing.postalCode": "payer.address.postalCode",
            "billing.countryCode": "payer.address.country",
            "description": "description",
            "meta": "meta",
            "currency": "currency"
          }
        }
      },
      "login": {
        "map": {
          "bankLogin.bankKey": "bankKey",
          "bankLogin.username": "username",
          "bankLogin.password": "password",
          "bankLogin.pin": "pin",
          "bankLogin.accountNumber": "accountNumber",
          "bankLogin.routingNumber": "routingNumber"
        }
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .constant('psConfig', {
      "version": "3.0",
      "publishableKey": "",
      "domain": "",
      "storeURL": "",
      "theme": "classic",
      "layout": "two-col",
      "details": {
        "shipping": "0.00",
        "subTotal": "0.00",
        "tax": "0.00",
        "service": "0.00",
        "processing": "0.00"
      },
      "currency": "USD",
      "payment": {
        //"amount": "",
        //"currency": "",
        //"type": "",
        //"status": ""
      },
      "customer": {
        "email": "",
        "name": ""
      },
      "paymentMethods": ['echeck', 'card'],
      "ui": {
        "show": false,
        "type": 'order',
        "showItems": false,
        "showShipping": false,
        "showService": false,
        "showProcessing": false,
        "showTax": true,
        "showSubTotal": false,
        "showTotal": true,
        "items": {}
      },
      "billing": {
        "show": true,
        "email": "",
        "name": "",
        "street": "",
        "subdivisionCode": "",
        "subdivisionName": "",
        "postalCode": "",
        "countryCode": "USA",
        "countryName": ""
      },
      "shipping": {
        "show": false,
        "email": "",
        "name": "",
        "street": "",
        "subdivisionCode": "",
        "subdivisionName": "",
        "postalCode": "",
        "countryCode": "",
        "countryName": "",
        "sameAsBilling": false
      },
      "card": {
        "name": ""
      },
      "echeck": {
        "name": ""
      },
      "bankLogin": {},
      "bitcoin": {},
      "meta": {}
    });

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .service('psCheckoutService', psCheckoutService);

  /** @ngInject */
  function psCheckoutService($log, _, psConfig, $rootScope, $mdDialog, psAlertService) {

    var vm = this;

    angular.extend(vm, {
      "service": {
        "getState": getState,
        "updateState": updateState,
        "updateConfig": updateConfig,
        "loadConfig": loadConfig,
        "setCheckoutType": setCheckoutType,
        "showScheduledPaymentInfo": showScheduledPaymentInfo,
        "formatTabName": formatTabName,
        "openScheduledPaymentDetails": openScheduledPaymentDetails,
        "closeScheduledPaymentDetails": closeScheduledPaymentDetails,
        "getUrl": getUrl,
        "currentVersion": "3.0",
        "checkoutType": "payment",
        "state": {}
      }
    });

    $rootScope.$watch("vm.service.state.scheduledPayment", setCheckoutType);
    $rootScope.$watch("vm.service.state.payment", setCheckoutType);

    loadDefaultConfig(psConfig);

    return vm.service;

    /**
     * Returns the state of the vm
     * @param path
     * @returns {object}
     */
    function getState(path) {
      if (path) {
        return _.get(vm.service.state, path);
      }
      else {
        return vm.service.state;
      }
    }

    /**
     * Update state
     * @param path
     * @param data
     */
    function updateState(path, data) {
      _.set(getState(), path, data);
    }

    /**
     * Initialize the vm data
     * @param config
     */
    function updateConfig(config) {
      var paymentMethods = _.get(config, 'paymentMethods');
      var firstPaymentMethod = _.head(paymentMethods);
      paymentMethods = _.isEmpty(paymentMethods) ? _.get(psConfig, 'paymentMethods') : paymentMethods;
      _.merge(getState(), config);
      updateState('paymentMethods', paymentMethods);
      updateState('payment.type', firstPaymentMethod);
      setCheckoutType();
      $log.log("checkout service data initialized:", getState());
    }

    /**
     * Load a new config
     * @param config
     */
    function loadConfig(config) {
      loadDefaultConfig();
      updateConfig(config);
    }

    /**
     * Load blank ps config
     */
    function loadDefaultConfig() {
      updateConfig(psConfig);
    }

    /**
     * Set checkout type
     */
    function setCheckoutType() {
      vm.checkoutType = 'payment';
      var hasScheduledPayment = !_.isEmpty(getState('scheduledPayment'));
      var hasPayment = !_.isEmpty(_.omit(getState('payment'), 'type'));
      if (hasScheduledPayment && hasPayment) {
        vm.service.checkoutType = 'both';
        psAlertService.error('Error: Can not specify both a payment and a scheduledPayment');
        openInvalidCheckoutModal();
      }
      else if (hasScheduledPayment && !hasPayment) {
        vm.service.checkoutType = 'scheduled';
      }
      else if (hasPayment) {
        vm.service.checkoutType = 'payment';
      }
      else if (!hasScheduledPayment && !hasPayment) {
        vm.service.checkoutType = 'tokenize';
      }
    }

    /**
     * Format tab name
     * @param tab
     * @returns {*}
     */
    function formatTabName(tab) {
      var formatted;
      if (tab == 'echeck') {
        formatted = "eCheck";
      }
      else if (tab == 'card') {
        formatted = _.startCase(tab);
      }
      return formatted;
    }

    /**
     * Is this the checkout type
     */
    function showScheduledPaymentInfo() {
      return _.includes(['both', 'scheduled'], vm.service.checkoutType);
    }

    /**
     * Open modal with scheduledPayment details
     */
    function openScheduledPaymentDetails() {
      $mdDialog.show({
        "templateUrl": "app/components/ps-checkout/ps-scheduled-payment/wizard/ps-scheduled-payment-wizard-modal.html",
        "parent": angular.element(document.body),
        "clickOutsideToClose": true,
        "openFrom": {
          "top": -50,
          "width": 30,
          "height": 80
        },
        "closeTo": {
          "left": 1500
        }
      });
    }

    /**
     * Open modal for invalid checkout
     */
    function openInvalidCheckoutModal() {
      $mdDialog.show({
        "templateUrl": "app/components/ps-checkout/ps-invalid/ps-invalid-modal.html",
        "parent": angular.element(document.body),
        "clickOutsideToClose": false,
        "escapeToClose": false,
        "openFrom": {
          "top": -50,
          "width": 30,
          "height": 80
        },
        "closeTo": {
          "left": 1500
        }
      });
    }

    /**
     * Close the scheduled payment details modal
     */
    function closeScheduledPaymentDetails() {
      $mdDialog.cancel();
    }

    /**
     * Get url
     * @param method
     */
    function getUrl(method) {
      return getState("domain") + "/v3/" + method;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .directive('psCheckout', psCheckout);

  /** @ngInject */
  function psCheckout() {
    var directive = {
      "restrict": "E",
      "templateUrl": "app/components/ps-checkout/ps-checkout.html",
      "scope": {},
      "controller": psCheckoutController,
      "controllerAs": "vm",
      "bindToController": true
    };

    return directive;

    /** @ngInject */
    function psCheckoutController($scope, $window, psCheckoutService, psExternal, psThemeService, _) {

      var vm = this;

      angular.extend(vm, {
        "service": psCheckoutService,
        "loaded": true,
        "isLayout": isLayout,
        "external": psExternal
      });

      psExternal.initialize();

      $scope.$watch(function () {
        return $scope.psCheckoutForm;
      }, updateForm, true);

      $scope.$watch(getLayout, setLayout);
      $scope.$watch(getTheme, psThemeService.setupMdTheme);
      $scope.$watch(getTheme, addThemeClassToBody);
      $scope.$watch(getPalette, psThemeService.setupMdTheme);
      $scope.$watch(getCss, psThemeService.addExternalCss);
      $scope.$watch(getFont, psThemeService.addGoogleFont);

      angular.element($window).bind('resize', updateLayoutOnResize);

      $scope.$watch(getScheduledPayment, vm.service.setCheckoutType);
      $scope.$watch(getPayment, vm.service.setCheckoutType);

      ////////////////

      /**
       * Update login form
       * @param newValue
       */
      function updateForm(newValue) {
        if (newValue != psCheckoutService.psForm) {
          psCheckoutService.psForm = newValue;
        }
      }

      /**
       * Set layout
       */
      function setLayout() {
        vm.layout = psThemeService.getLayout(getLayout());
      }

      /**
       * Is this the layout
       * @param layout
       * @returns {boolean}
       */
      function isLayout(layout) {
        return vm.layout == layout;
      }

      /**
       * Add the theme class to the body
       */
      function addThemeClassToBody() {
        var themeClass = "ps-theme-" + getTheme();
        var body = document.getElementsByTagName('body')[0];
        var classArray = body.className.split(' ');
        classArray = _.remove(classArray, function (aClass) {
          return !_.includes(aClass, 'ps-theme');
        });
        classArray.push(themeClass);
        _.remove(classArray, function (item) {
          return _.isEmpty(item);
        });
        var classString = classArray.join(' ');
        body.className = classString;
      }

      /**
       * Update layout on resize
       */
      function updateLayoutOnResize() {
        if (getWidth() < 400) {
          //vm.layout = 'mini';
        }
        else {
          //setLayout();
        }
      }

      /**
       * Get width
       * @returns {*}
       */
      function getWidth() {
        return $window.innerWidth;
      }

      /**
       * Get css
       * @returns {*}
       */
      function getCss() {
        return psCheckoutService.getState('css');
      }

      /**
       * Get layout
       * @returns {*}
       */
      function getLayout() {
        return psCheckoutService.getState('layout');
      }

      /**
       * Get theme
       * @returns {*}
       */
      function getTheme() {
        return psCheckoutService.getState('theme');
      }

      /**
       * Get palette
       * @returns {*}
       */
      function getPalette() {
        return psCheckoutService.getState('palette');
      }

      /**
       * Get font
       * @returns {*}
       */
      function getFont() {
        return psCheckoutService.getState('font');
      }

      /**
       * Get scheduled payment
       * @returns {*}
       */
      function getScheduledPayment() {
        return psCheckoutService.getState('scheduledPayment');
      }

      /**
       * Get payment
       * @returns {*}
       */
      function getPayment() {
        return psCheckoutService.getState('payment');
      }

    }
  }

})();

/*
 *
 * PayStand Checkout
 * version 3.0
 * http://www.paystand.com/
 *
 */

var PayStandCheckout = {

  /**
   * Config
   */
  config: {},

  iFrameID: "paystand_checkout_iframe",

  checkout_frame: "null",

  /**
   * Init
   * @param config
   * @param width
   * @param height
   */
  init: function (config, width, height) {
    config.checkoutDomain = config.checkoutDomain || config.checkout_domain;
    if (!config.checkoutDomain) {
      var frame = document.getElementById(this.iFrameID);
      if (frame) {
        frame.contentWindow.postMessage(config, "*");
      }
      return;
    }
    PayStandCheckout.listening = false;
    PayStandCheckout._listen();
    this.config = config;
    var _height = (typeof height === 'undefined' || height === null) ? "100vh" : height + "px";
    var _width = (typeof width === 'undefined' || width === null) ? "100%" : width + "px";
    var container = document.createElement('div');
    container.id = "paystand_checkout_div";
    container.style.width = _width;
    container.style.height = _height;
    var obj_script = document.getElementById('paystand_checkout');
    obj_script.parentNode.insertBefore(container, obj_script);
    this.checkout_frame = document.createElement("iframe");
    this.checkout_frame.id = this.iFrameID;
    this.checkout_frame.width = "100%";
    this.checkout_frame.height = "100%";
    this.checkout_frame.frameBorder = 0;
    this.checkout_frame.allowTransparency = "true";
    this.checkout_frame.vspace = 0;
    this.checkout_frame.hspace = 0;
    this.checkout_frame.marginheight = 0;
    this.checkout_frame.marginwidth = 0;
    //this.checkout_frame.style.overflow = "hidden";
    this.checkout_frame.src = config.checkoutDomain + "index.html";
    setTimeout(function () {
      container.appendChild(PayStandCheckout.checkout_frame);
    }, 1);
  }

};

/* eslint-disable no-console */

/**
 * Implement PayStandCheckout.checkoutUpdated
 */
PayStandCheckout.checkoutUpdated = PayStandCheckout.checkoutUpdated || function (data) {
    console.log("checkout updated:", data);
  };

/**
 * Implement PayStandCheckout.checkoutComplete
 */
PayStandCheckout.checkoutComplete = PayStandCheckout.checkoutComplete || function (data) {
    console.log("checkout complete:", data);
  };

/**
 * Implement PayStandCheckout.checkoutFailed
 */
PayStandCheckout.checkoutFailed = PayStandCheckout.checkoutFailed || function (data) {
    console.log("checkout failed:", data);
  };

/* eslint-enable no-console */

/**
 * Listen for
 */
PayStandCheckout.listenFor = PayStandCheckout.listenFor || function (eventName, responseFunction) {
    PayStandCheckout.callbackEvents = PayStandCheckout.callbackEvents || {};
    PayStandCheckout.callbackEvents[eventName] = PayStandCheckout.callbackEvents[eventName] || [];
    PayStandCheckout.callbackEvents[eventName].push(responseFunction);
  };

/**
 * Listen Checkout Updated
 */
PayStandCheckout.listenFor("checkoutUpdated", function (data) {
  PayStandCheckout.checkoutUpdated(data);
});

/**
 * Listen Checkout Complete
 */
PayStandCheckout.listenFor("checkoutComplete", function (data) {
  PayStandCheckout.checkoutComplete(data);
});

/**
 * Listen Checkout Failed
 */
PayStandCheckout.listenFor("checkoutFailed", function (data) {
  PayStandCheckout.checkoutFailed(data);
});

/**
 * Trigger
 */
PayStandCheckout.trigger = PayStandCheckout.trigger || function (eventName, data) {
    var callbacks = PayStandCheckout.callbackEvents[eventName];
    if (callbacks) {
      for (var i = 0; i < callbacks.length; i++) {
        var callback = callbacks[i];
        callback(data);
      }
    }
  };

/**
 * Receive Message
 */
PayStandCheckout.receiveMessage = PayStandCheckout.receiveMessage || function (data) {
    PayStandCheckout.trigger(data.type, data);
  };

/**
 * Listeners
 */
PayStandCheckout._listen = function () {
  function receiveMessage(e) {
    if (typeof e !== 'undefined' && e.data === "sendConfiguration") {
      var frame = document.getElementById(PayStandCheckout.iFrameID);
      frame.contentWindow.postMessage(PayStandCheckout.config, "*");
    }
    else {
      PayStandCheckout.receiveMessage(e.data);
    }
  }

  if (!PayStandCheckout.listening) {
    window.addEventListener("message", receiveMessage);
    PayStandCheckout.listening = true;
  }
};



(function (exports) {

  // Configuration specific part of the init hash for checkout
  // as well as common properties that we don't want to clutter the demo
  exports.init = {
    "publishableKey": "dswk9d1kloe9po35riuhgzyt", // Stripe
    //"publishableKey": "m08twybi12slq7o6priyae4z", // Vantiv
    // "checkoutDomain": "https://checkout.paystand.vagrant/v3/",
    "checkoutDomain": "http://localhost:3003/", // For development
    "domain": "https://localhost:3001/api",
    "font": "Montserrat"
  }

})(typeof exports === 'undefined' ? this['psConfig'] = {} : exports);
(function() {
  'use strict';

  angular
    .module('psCheckout2')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

/* global malarkey:false, moment:false */
/* eslint-disable angular/window-service */
(function () {
  'use strict';

  angular
    .module('psCheckout2')
    .constant('_', window._)
    .constant('moment', moment)
    .factory('Big', function ($window) {
      return $window.Big;
    });

})();
/* eslint-enable angular/window-service */
(function() {
  'use strict';

  angular
    .module('psCheckout2')
    .config(config);

  /** @ngInject */
  function config($logProvider, $mdThemingProvider, $provide) {
    // Enable log
    $logProvider.debugEnabled(true);

    $mdThemingProvider.definePalette('amazingPaletteName', {
      '50': 'ffebee',
      '100': 'ffcdd2',
      '200': 'ef9a9a',
      '300': 'e57373',
      '400': 'ef5350',
      '500': 'f44336',
      '600': 'e53935',
      '700': 'd32f2f',
      '800': 'c62828',
      '900': 'b71c1c',
      'A100': 'ff8a80',
      'A200': 'ff5252',
      'A400': 'ff1744',
      'A700': 'E57373',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
      'contrastLightColors': undefined
    });

    $mdThemingProvider.theme('classic')
      .primaryPalette('blue')
      .accentPalette('light-blue')
      .warnPalette('amazingPaletteName');

    $mdThemingProvider.theme('darcula')
      .primaryPalette('grey')
      .accentPalette('pink')
      .warnPalette('red')
      .backgroundPalette('blue-grey');

    $mdThemingProvider.theme('oneup')
      .primaryPalette('lime')
      .accentPalette('orange')
      .warnPalette('blue');

    $mdThemingProvider.theme('paystand-modern')
      .primaryPalette('green')
      .accentPalette('orange')
      .warnPalette('red');

    $provide.value('themeService', $mdThemingProvider);
  }

})();

(function () {
  'use strict';

  angular
    .module('psApplication', [
      'psCheckout2'
    ]);

})();

angular.module("psCheckout2").run(["$templateCache", function($templateCache) {$templateCache.put("app/demo/condo.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"><link rel=\"stylesheet\" href=\"https://ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.css\"><link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\"><style>\n    .logo {\n      max-width: 108px;\n      height: auto;\n      padding-bottom: 20px;\n    }\n\n    .header {\n      padding: 20px;\n      align-items: center;\n      font-size: xx-large;\n    }\n\n    .footer {\n      padding: 10px;\n      text-align: center;\n      width: 100%;\n    }\n\n    input[type=number] {\n      text-align: right;\n    }\n\n    .co-dialog {\n      width: 400px;\n      margin: 30px 30px 30px 30px;\n    }\n\n    .md-dialog-container {\n      display: flex;\n      justify-content: flex-end;\n      position: absolute;\n      align-items: flex-start;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 1000px !important;\n    }\n\n  </style></head><body ng-app=\"BlankApp\" ng-cloak=\"\"><md-toolbar class=\"header\"><img src=\"ps-hood-white.png\" class=\"logo\"> PayStand Pacific Condos</md-toolbar><md-content class=\"md-padding\"><p>Welcome to PayStand Pacific Condominiums. Please enter your lease contract details below to pay your application fee, submit your security deposit and setup your monthly rent.</p><form name=\"condoLeaseForm\" ng-controller=\"leaseController\" novalidate=\"\" layout-margin=\"\"><div layout=\"row\"><div flex=\"\" layout=\"column\"><md-input-container flex-offset=\"50\"><label>Lease Agreement Number</label> <input name=\"leaseNumber\" ng-model=\"leaseNumber\" required=\"\" md-maxlength=\"6\" minlength=\"6\"><div ng-messages=\"condoLeaseForm.leaseNumber.$error\" ng-show=\"condoLeaseForm.leaseNumber.$dirty\"><div ng-message=\"required\">Lease number is required!</div><div ng-message=\"md-maxlength\">Lease number should be exactly 6 characters!</div><div ng-message=\"minlength\">Lease number should be exactly 6 characters!</div></div></md-input-container><md-input-container><label>Tentant(s) Full Name</label> <input name=\"fullName\" ng-model=\"fullName\" required=\"\" md-maxlength=\"40\" md-minlength=\"4\"><div ng-messages=\"condoLeaseForm.fullName.$error\" ng-show=\"condoLeaseForm.fullName.$dirty\"><div ng-message=\"required\">Full name is required!</div><div ng-message=\"maxlength\">Not more than the first 40 characters!</div><div ng-message=\"minlength\">Full name should be at least 4 characters!</div></div></md-input-container><md-input-container><label>Property Address</label> <input name=\"address\" ng-model=\"address\" required=\"\" md-maxlength=\"125\"><div ng-messages=\"condoLeaseForm.address.$error\" ng-show=\"condoLeaseForm.address.$dirty\"><div ng-message=\"required\">Lease number is required!</div><div ng-message=\"md-maxlength\">Address cannot be longer than 125 characters!</div></div></md-input-container><md-datepicker name=\"startDate\" ng-model=\"startDate\" md-placeholder=\"Start date\" required=\"\" md-min-date=\"now();\" md-max-date=\"maxDate\"></md-datepicker><div class=\"validation-messages\" ng-messages=\"condoLeaseForm.startDate.$error\" ng-show=\"condoLeaseForm.startDate.$dirty\"><div ng-message=\"valid\">The entered value is not a valid date!</div><div ng-message=\"required\">The start date is required!</div><div ng-message=\"mindate\">The start date cannot be in the past!</div><div ng-message=\"maxdate\">Date is too late!</div></div><div layout=\"row\" layout-align=\"space-between\"><md-input-container><label>Monthly Rent</label> <input name=\"rent\" ng-model=\"rent\" required=\"\" type=\"number\" text-align=\"right\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\"><div ng-messages=\"condoLeaseForm.rent.$error\" ng-show=\"condoLeaseForm.rent.$dirty\"><div ng-message=\"required\">Rent is required!</div></div></md-input-container><md-input-container><label>Term in months</label> <input name=\"term\" ng-model=\"term\" required=\"\" type=\"number\" step=\"any\" min=\"3\" max=\"36\" ng-pattern=\"/[0-9]{1,2}/\"><div ng-messages=\"condoLeaseForm.term.$error\" ng-show=\"condoLeaseForm.term.$dirty\"><div ng-message=\"required\">Term is required!</div><div ng-message=\"min\">Minimum 3 months!</div><div ng-message=\"max\">Maximum 36 months!</div></div></md-input-container></div><md-input-container><label>Notes</label> <textarea name=\"notes\" ng-model=\"notes\" md-maxlength=\"150\" placeholder=\"Any additional notes as needed\"></textarea><div ng-messages=\"condoLeaseForm.notes.$error\" ng-show=\"condoLeaseForm.notes.$dirty\"><div ng-message=\"md-maxlength\">That\'s too long!</div></div></md-input-container></div><div flex=\"\" flex-gt-xs=\"50\" layout-padding=\"\" layout-margin=\"\"><div class=\"md-whiteframe-2dp\" layout=\"column\"><md-subheader class=\"md-primary\"><h1>Summary</h1></md-subheader><md-list><md-list-item><p>Lease</p>{{leaseNumber}}</md-list-item><md-list-item><p>Tenant</p>{{fullName}}</md-list-item><md-list-item><p>Property</p>{{address}}</md-list-item><md-list-item><p>Application Fee</p>$50.00</md-list-item><md-list-item><p>Security Deposit</p>{{3 * rent | currency}}</md-list-item><md-list-item><p>Monthly Rent</p>{{1 * rent | currency}}</md-list-item><md-list-item><p>Start</p>{{startDate | date}}</md-list-item><md-list-item><p>Lease Term</p>{{1 * term}}</md-list-item><md-divider></md-divider><md-list-item><md-button class=\"md-primary md-raised\" aria-label=\"Enter payment method\" id=\"dialogWayPoint\" type=\"submit\" layout-fill=\"\" ng-click=\"schedulePayment();\" ng-disabled=\"condoLeaseForm.$invalid\">Enter payment method</md-button></md-list-item></md-list></div></div></div></form></md-content><md-divider></md-divider><div class=\"footer\"><md-button class=\"md-accent md-raised md-hue-2\">This is a demo system</md-button><p>Copyright 2016 PayStand Inc</p><a href=\"https://codepen.io/paystand/pen/JXOBMG\"><img src=\"https://blog.codepen.io/wp-content/uploads/2012/06/TryItOn-CodePen.svg\"></a></div><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-animate.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-aria.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-messages.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.js\"></script><script type=\"text/javascript\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  /**\n   * You must include the dependency on \'ngMaterial\'\n   */\n  angular.module(\'BlankApp\', [\'ngMaterial\', \'ngMessages\'])\n    .controller(\'leaseController\', function ($scope, $mdDialog) {\n      angular.extend($scope, {\n          \"fullName\": null,\n          \"address\": null,\n          \"leaseNumber\": null,\n          \"rent\": null,\n          \"term\": null,\n          \"startDate\": null,\n          \"notes\": null\n        }\n      );\n\n\n      $scope.schedulePayment = function () {\n        $mdDialog.show({\n          clickOutsideToClose: true,\n          scope: $scope,        // use parent scope in template\n          preserveScope: true,  // do not forget this if use parent scope\n          template: \'<md-dialog class=\"co-dialog\"><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" flex layout=\"row\" layout-align=\"end none\">\' +\n          \'<i class=\"material-icons\">close</i></md-button>\' +\n          \'  <md-dialog-content>\' +\n          \'     <div id=\"paystand_checkout\"></div>\' +\n          \'  </md-dialog-content>\' +\n          \'</md-dialog>\',\n          controller: function DialogController($scope, $mdDialog) {\n            $scope.closeDialog = function () {\n              $mdDialog.hide();\n            }\n          }\n        });\n        setTimeout(function () {\n          $scope.schedule();\n        }, 1);\n        //$scope.schedule();\n      };\n\n      $scope.schedule = function () {\n        var initSchedule = {\n          \"version\": \"3.0\",\n          \"currency\": \"USD\",\n          \"payer\": {\n            \"name\": $scope.fullName\n          },\n          \"paymentMethods\": [\"echeck\"],\n          \"meta\": {\n            \"fullName\": $scope.fullName,\n            \"address\": $scope.address,\n            \"leaseNumber\": $scope.leaseNumber,\n            \"rent\": $scope.rent,\n            \"term\": $scope.term,\n            \"startDate\": $scope.startDate,\n            \"notes\": $scope.notes\n          },\n          \"scheduledPayment\": {\n            \"name\": \"Lease number: \" + $scope.leaseNumber,\n            \"description\": $scope.address,\n            \"scheduledItems\": [\n              {\n                \"name\": \"Application Fee\",\n                \"description\": \"One time application fee of $50.00\",\n                \"schedule\": {\n                  \"name\": \"Application Fee\",\n                  \"description\": \"Pay a one time non-refundable application fee\"\n                },\n                \"amount\": \"50.00\"\n              },\n              {\n                \"name\": \"Security Deposit\",\n                \"description\": \"Refundable security deposit of 3 times the monthly rent\",\n                \"schedule\": {\n                  \"name\": \"Security Deposit\",\n                  \"dateStart\": \"2016-04-01T00:00\"\n                },\n                \"amount\": (3 * $scope.rent).toString()\n              },\n              {\n                \"name\": \"Monthly Rent\",\n                \"schedule\": {\n                  \"name\": \"Rent\",\n                  \"interval\": \"month\",\n                  \"intervalCount\": \"1\",\n                  \"dateStart\": $scope.startDate,\n                  \"timesToRun\": $scope.term\n                },\n                \"amount\": ($scope.rent).toString()\n              }\n            ]\n          }\n\n        };\n\n        if (window.psConfig) {\n          /**\n           * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n           */\n          PayStandCheckout.init(angular.merge(window.psConfig.init, initSchedule));\n        } else {\n          alert(\"Demo configuration could not be loaded!\");\n        }\n      };\n\n    });\n\n\n</script></body></html>");
$templateCache.put("app/demo/customization.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"><link rel=\"stylesheet\" href=\"//ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.css\"></head><body ng-app=\"BlankApp\" ng-cloak=\"\"><md-content class=\"md-padding\" ng-controller=\"vm\"><div layout=\"row\"><div flex=\"\" layout=\"column\"><md-input-container><label>Theme</label><md-select ng-model=\"state.theme\"><md-option ng-repeat=\"theme in themes\">{{ theme }}</md-option></md-select></md-input-container><md-input-container><label>Layout</label><md-select ng-model=\"state.layout\"><md-option ng-repeat=\"layout in layouts\">{{ layout }}</md-option></md-select></md-input-container><p>Palette</p><md-input-container><label>Primary</label><md-select ng-model=\"state.palette.primary\"><md-option ng-repeat=\"color in colors\">{{ color }}</md-option></md-select></md-input-container><md-input-container><label>Accent</label><md-select ng-model=\"state.palette.accent\"><md-option ng-repeat=\"color in colors\">{{ color }}</md-option></md-select></md-input-container><md-input-container><label>Warn</label><md-select ng-model=\"state.palette.warn\"><md-option ng-repeat=\"color in colors\">{{ color }}</md-option></md-select></md-input-container></div><div flex=\"\" flex-gt-xs=\"50\"><div id=\"paystand_checkout\"></div></div></div></md-content><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular.min.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-animate.min.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-aria.min.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-messages.min.js\"></script><script src=\"//ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.js\"></script><script type=\"text/javascript\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"version\": \"3.0\",\n    //\"css\": \"https://s3-us-west-2.amazonaws.com/colors-css/2.2.0/colors.min.css\",\n//    \"css\": \"demo/external.css\",\n    \"logo\": {\n      \"url\": \"http://chrisdesigns.net/chris/images/logos/chrisdesignslogostill.png\",\n      \"width\": \"100\",\n      \"height\": \"100\"\n    },\n//    \"palette\": {\n//      \"primary\": \"purple\",\n//      \"accent\": \"pink\",\n//      \"warn\": \"red\"\n//    },\n//    \"palette\": {\n//      \"primary\": {\n//        \"pink\": {\n//          \'default\': \'400\',\n//          \'hue-1\': \'100\',\n//          \'hue-2\': \'600\',\n//          \'hue-3\': \'A100\'\n//        }\n//      },\n//      \"accent\": \"purple\",\n//      \"warn\": \"red\"\n//    },\n    \"font\": \"Montserrat\",\n    \"currency\": \"USD\",\n    \"details\": {\n      \"shipping\": \"4.00\",\n      \"service\": \"5.00\",\n      \"tax\": \"1.20\",\n      \"processing\": \"2.50\"\n    },\n    \"payment\": {\n      \"amount\": \"5000.20\"\n    },\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"postalCode\": \"123456\",\n    \"paymentMethods\": [\"echeck\", \"card\"],\n    \"card\": {\n      \"number\": \"4242 4242 4242 4242\",\n      \"securityCode\": \"123\"\n    },\n    \"billing\": {\n      \"show\": true,\n      \"street\": \"41 Ocean St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"meta\": {}\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(angular.merge(window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script><script type=\"text/javascript\">\n  /**\n   * You must include the dependency on \'ngMaterial\'\n   */\n  angular.module(\'BlankApp\', [\'ngMaterial\'])\n    .controller(\'vm\', function ($scope) {\n      angular.extend($scope, {\n          \"layouts\": [\n            \"two-col\",\n            \"backwards\",\n            \"mini\",\n            \"one-col\",\n            \"stacked\"\n          ],\n          \"themes\": [\n            \"classic\",\n            \"oneup\",\n            \"darcula\"\n          ],\n          \"colors\": [\n            \"red\",\n            \"pink\",\n            \"purple\",\n            \"deep-purple\",\n            \"indigo\",\n            \"blue\",\n            \"light-blue\",\n            \"cyan\",\n            \"teal\",\n            \"green\",\n            \"light-green\",\n            \"lime\",\n            \"yellow\",\n            \"amber\",\n            \"orange\",\n            \"deep-orange\",\n            \"brown\",\n            \"grey\",\n            \"blue-grey\"\n          ],\n          \"paletteTypes\": [\n            \"primary\",\n            \"accent\",\n            \"warn\"\n          ],\n          \"state\": {\n            \"layout\": \"one-col\",\n            \"theme\": \"classic\",\n            \"palette\": {\n              \"primary\": \"orange\",\n              \"accent\": \"orange\",\n              \"warn\": \"orange\"\n            }\n          }\n        }\n      );\n\n      // TODO XXX: FIX THIS. THIS IS BROKEN\n      // I.e. checkout is not keeping the state of its previous initialization\n      $scope.updateCheckout = function (newVal) {\n        PayStandCheckout.init(newVal);\n      };\n\n      $scope.$watch(function () {\n          return $scope.state;\n        },\n        function (newVal) {\n          $scope.updateCheckout(newVal);\n        }, true);\n\n    });\n\n\n</script></body></html>");
$templateCache.put("app/demo/demo.html","<!DOCTYPE html><html><head><title>PayStand Checkout 3.0 Embed Example</title><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"payment\": {\n      \"amount\": \"5000.20\",\n      \"currency\": \"USD\"\n    },\n    \"currency\": \"USD\",\n    \"paymentMethods\": [\n      \"echeck\",\n      \"card\"\n    ],\n    \"billing\": {\n      \"show\": true,\n      \"street\": \"41 Grandview St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"demo+cchan@paystand.com\"\n    },\n    \"meta\": {},\n    \"demo\": true\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n\n</script></body></html>");
$templateCache.put("app/demo/direct-payment.html","<!DOCTYPE html><html><head><title>PayStand Checkout 3.0 Embed Example</title><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"payment\": {\n      \"amount\": \"4800.20\"\n    },\n    \"currency\": \"USD\",\n    \"paymentMethods\": [\n      \"echeck\",\n      \"card\"\n    ],\n    \"billing\": {\n      \"show\": true,\n      \"street\": \"41 Grandview St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"meta\": {}\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script></body></html>");
$templateCache.put("app/demo/index.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"><link rel=\"stylesheet\" href=\"https://ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.css\"><link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\"><style>\n    .logo {\n      max-width: 108px;\n      height: auto;\n      padding-bottom: 20px;\n    }\n\n    .header {\n      padding: 20px;\n      align-items: center;\n      font-size: xx-large;\n    }\n\n    .footer {\n      padding: 10px;\n      text-align: center;\n      width: 100%;\n    }\n\n  </style></head><body ng-app=\"BlankApp\" ng-cloak=\"\"><md-toolbar class=\"header\"><img src=\"ps-hood-white.png\" class=\"logo\"> PayStand Checkout 3.0 Examples</md-toolbar><md-content class=\"md-padding\"><p>Welcome to the PayStand Checkout 3.0 examples page. Each of the examples below highlights a specific feature or use case of checkout 3.0. Follow the Codepen links to play with the parameters of these demos.</p><md-divider></md-divider><h1>Checkout 3.0 Modes</h1><h2><a href=\"direct-payment.html\">Regular (Direct) Payment</a></h2><p>This example shows how checkout 3.0 can be embeded in a page to collect a regular payment (immediately executed) by calling PayStandCheckout.init with an object containing a <strong>payment property</strong>.</p><h2><a href=\"scheduled-payment.html\">Scheduled Payment</a></h2><p>This example shows how checkout 3.0 can be embeded in a page to setup a scheduled payment by calling PayStandCheckout.init with an object containing a <strong>scheduledPayment property</strong>.</p><p>It also demonstrates how 1 scheduled payment can contain multiple <strong>scheduledItems</strong> and how a scheduledItem can be a <strong>regular (direct) payment</strong>, a <strong>delayed payment</strong> or a <strong>recurring payment</strong>.</p><h2><a href=\"tokenize.html\">Save Card or Bank</a></h2><p>This example shows how checkout 3.0 can be embeded in a page to collect a payment method (Card or Bank) by calling PayStandCheckout.init with an object containing <strong>no payment or scheduledPayment property</strong>.</p><p>The returned token can be used only once from the non-authenticated front-end to submit a subsequent Payment or Scheduled Payment, or the contained bankId or cardId may be used by an authenticated and authorized backend to submit one or more payments or scheduledPayments in the future.</p><md-divider></md-divider><h1>Customer Use Cases</h1><h2><a href=\"condo.html\">PayStand Pacific Condos</a></h2><p>The PayStand Pacific Condos example demonstrates the application of PayStand\'s <strong>scheduled payments</strong> feature.</p><p>It shows how a condo rental company can use 1 scheduled payment to line up a <strong>1 time payment</strong> (Application Fee), a <strong>delayed payment</strong> (Security Deposit) and a <strong>recurring payment</strong> (Rent) all at the same time inside the context of <strong>just 1 scheduled payment</strong>.</p><md-divider></md-divider><h1>Customization</h1><h2><a href=\"customization.html\">Customization Demo</a></h2><p>The Customization Demo shows how checkout 3.0 can be customized using set of predefined <strong>themes</strong>, <strong>layouts</strong> and <strong>color pallets</strong>.</p><p>Additionally it can be used to get to a starting point (i.e. determine a starting combination of theme, layout and color pallets) closer to what the design ultimately has to become before starting CSS based customizations. That way there will be less CSS overrides needed.</p><h2>Skinning Checkout 3.0 using CSS</h2><p>Coming soon!</p><md-divider></md-divider><md-divider></md-divider></md-content><div class=\"footer\"><md-button class=\"md-accent md-raised md-hue-2\">This is a demo system</md-button><p>Copyright 2016 PayStand Inc</p><a href=\"https://codepen.io/paystand/\"><img src=\"https://blog.codepen.io/wp-content/uploads/2012/06/TryItOn-CodePen.svg\"></a></div><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-animate.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-aria.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angularjs/1.5.3/angular-messages.min.js\"></script><script src=\"https://ajax.googleapis.com/ajax/libs/angular_material/1.0.5/angular-material.min.js\"></script><script type=\"text/javascript\">\n  /**\n   * You must include the dependency on \'ngMaterial\'\n   */\n  angular.module(\'BlankApp\', [\'ngMaterial\', \'ngMessages\']);\n\n</script></body></html>");
$templateCache.put("app/demo/plain-v2.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"apiVersion\": \"2.0\",\n    \"template\": \"default\",\n    \"theme\": \"default\",\n    \"total\": \"10.00\",\n    \"currency\": \"USD\",\n    \"features\": {\n      \"cards\": true,\n      \"echeck\": {\n        \"enabled\": true\n      }\n    },\n    \"ui\": {\n      \"billing\": {\n        \"show\": false,\n        \"autoFill\": {\n          \"email\": \"cchen+test@paystand.com\",\n          \"fullName\": \"Test User\",\n          \"street1\": \"123 Test St\",\n          \"street2\": \"Apt 3G\",\n          \"city\": \"Test\",\n          \"postalCode\": \"95060\",\n          \"state\": \"CA\",\n          \"country\": \"USA\"\n        }\n      },\n      \"shipping\": {\n        \"show\": true\n      }\n    },\n    \"meta\": {},\n    // todo: this is a hack that i need to figure out\n    \"payment\": {\n      \"type\": \"card\"\n    },\n    \"card\": {\n      \"number\": \"4242424242424242\",\n      \"securityCode\": \"123\"\n    }\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script></body></html>");
$templateCache.put("app/demo/plain-v3.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"version\": \"3.0\",\n    \"theme\": \"classic\",\n    \"layout\": \"compact\",\n    //\"css\": \"https://s3-us-west-2.amazonaws.com/colors-css/2.2.0/colors.min.css\",\n    //    \"css\": \"demo/external.css\",\n//    \"css\": \"demo/sports-pay.css\",\n//    \"logo\": {\n//      \"url\": \"http://chrisdesigns.net/chris/images/logos/chrisdesignslogostill.png\",\n//      \"width\": \"100\",\n//      \"height\": \"100\"\n//    },\n    //    \"palette\": {\n    //      \"primary\": \"purple\",\n    //      \"accent\": \"pink\",\n    //      \"warn\": \"red\"\n    //    },\n    //    \"palette\": {\n    //      \"primary\": {\n    //        \"pink\": {\n    //          \'default\': \'400\',\n    //          \'hue-1\': \'100\',\n    //          \'hue-2\': \'600\',\n    //          \'hue-3\': \'A100\'\n    //        }\n    //      },\n    //      \"accent\": \"purple\",\n    //      \"warn\": \"red\"\n    //    },\n    \"font\": \"Montserrat\",\n    \"currency\": \"USD\",\n    \"details\": {\n      \"shipping\": \"4.00\",\n      \"service\": \"5.00\",\n      \"tax\": \"1.20\",\n      \"processing\": \"2.50\"\n    },\n    \"payment\": {\n      \"amount\": \"5000.20\"\n    },\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"postalCode\": \"123456\",\n    \"paymentMethods\": [\"card\", \"echeck\"],\n    \"card\": {\n      \"number\": \"4242 4242 4242 4242\",\n      \"securityCode\": \"123\"\n    },\n    \"billing\": {\n      \"show\": true,\n      \"street\": \"41 Grandview St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"meta\": {}\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n\n</script></body></html>");
$templateCache.put("app/demo/scheduled-payment.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"apiVersion\": \"3.0\",\n    \"theme\": \"classic\",\n    \"layout\": \"two-col\",\n    \"currency\": \"USD\",\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"postalCode\": \"123456\",\n    \"paymentMethods\": [\n      \"echeck\",\n      \"card\"\n    ],\n    \"card\": {\n//      \"number\": \"4242 4242 4242 4242\",\n//      \"securityCode\": \"123\"\n    },\n    \"billing\": {\n      \"show\": true,\n      \"street\": \"41 Grandview St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"meta\": {},\n    \"scheduledPayment\": {\n      \"name\": \"One year lease\",\n      \"description\": \"120 Swift St. 12 Month Lease\",\n      \"scheduledItems\": [\n        {\n          \"name\": \"Monthly Rent\",\n          \"description\": \"Rent of $1200 is due on the first of every month\",\n          \"schedule\": {\n            \"name\": \"Rent\",\n            \"description\": \"Pay rent on the 1st of the month\",\n            \"interval\": \"month\",\n            \"intervalCount\": \"1\",\n            \"anchor\": \"start\",\n            \"dateStart\": \"2016-04-01T00:00\",\n            \"timesToRun\": \"12\"\n          },\n          \"amount\": \"1200.00\"\n        },\n        {\n          \"name\": \"Application Fee\",\n          \"description\": \"One time application fee of $150.00\",\n          \"schedule\": {\n            \"name\": \"Application Fee\",\n            \"description\": \"Pay a one time non-refundable application fee\"\n          },\n          \"amount\": \"150.00\"\n        },\n        {\n          \"name\": \"Security Deposit\",\n          \"description\": \"$2000 Refundable security deposit that can be used to cover damages\",\n          \"schedule\": {\n            \"name\": \"Deposit\",\n            \"description\": \"Security deposit or the home\",\n            \"dateStart\": \"2016-04-01T00:00\"\n          },\n          \"amount\": \"2000.00\"\n        }\n      ]\n    }\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script></body></html>");
$templateCache.put("app/demo/tokenize.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"config.js\"></script><script type=\"text/javascript\" src=\"../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"currency\": \"USD\",\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"payerId\": \"\",\n    \"postalCode\": \"123456\",\n    \"paymentMethods\": [\n      \"echeck\",\n      \"card\"\n    ],\n    \"card\": {\n//      \"number\": \"4242 4242 4242 4242\",\n//      \"securityCode\": \"123\"\n    },\n    \"billing\": {\n      \"street\": \"100 Enterprise Way\",\n      \"city\": \"Scotts Valley\",\n      \"postalCode\": \"95066\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"meta\": {\n      \"tokenize\": \"fund\"\n    }\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script></body></html>");
$templateCache.put("app/demo/custom/sports-pay.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"></head><body><script type=\"application/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.11.1/lodash.min.js\"></script><script type=\"text/javascript\" id=\"paystand_checkout\" src=\"../config.js\"></script><script type=\"text/javascript\" src=\"../../js/paystand.checkout.js\"></script><script type=\"text/javascript\">\n  var initSchedule = {\n    \"theme\": \"classic\",\n    \"layout\": \"stacked\",\n    \"css\": \"demo/css/sports-pay.css\",\n    \"font\": \"Montserrat\",\n    \"currency\": \"USD\",\n    \"payment\": {\n      \"amount\": \"5000.20\"\n    },\n    \"payer\": {\n      \"name\": \"Christina Chan\",\n      \"email\": \"cchen+tina@paystand.com\"\n    },\n    \"paymentMethods\": [\'card\', \'echeck\'],\n    \"billing\": {\n      \"street\": \"41 Swift St\",\n      \"city\": \"Santa Cruz\",\n      \"postalCode\": \"95060\",\n      \"subdivisionCode\": \"CA\",\n      \"countryCode\": \"USA\"\n    },\n    \"meta\": {}\n  };\n\n  if (window.psConfig) {\n    /**\n     * Publishable Key, checkoutDomain and domain are sourced from the front-end specific psConfig\n     */\n    PayStandCheckout.init(_.merge({}, window.psConfig.init, initSchedule));\n  } else {\n    alert(\"Demo configuration could not be loaded!\");\n  }\n</script></body></html>");
$templateCache.put("app/components/ps-checkout/ps-checkout.html","<div ng-hide=\"vm.external.received\" style=\"text-align:center; width:250px; margin: 80px auto 0 auto\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><br>Loading ...</div><div ng-show=\"vm.external.received\"><form name=\"psCheckoutForm\" layout=\"column\"><div ng-if=\"vm.isLayout(\'compact\')\"><ps-layout-compact></ps-layout-compact></div><div ng-if=\"vm.isLayout(\'one-col\')\"><ps-layout-one-col></ps-layout-one-col></div><div ng-if=\"vm.isLayout(\'stacked\')\"><ps-layout-stacked></ps-layout-stacked></div><div ng-if=\"vm.isLayout(\'two-col\')\"><ps-layout-two-col></ps-layout-two-col></div><div ng-if=\"vm.service.state.demo\"><ps-demo></ps-demo></div></form></div>");
$templateCache.put("app/components/ps-checkout/ps-address/ps-address.html","<ps-address-street purpose=\"{{purpose}}\"></ps-address-street><div layout=\"row\"><ps-address-city purpose=\"{{purpose}}\" flex=\"45\"></ps-address-city><div flex=\"5\"></div><ps-address-subdivision purpose=\"{{purpose}}\" flex=\"50\"></ps-address-subdivision></div><div layout=\"row\"><ps-address-postal purpose=\"{{purpose}}\" flex=\"35\"></ps-address-postal><div flex=\"5\"></div><ps-address-country purpose=\"{{purpose}}\" flex=\"60\"></ps-address-country></div>");
$templateCache.put("app/components/ps-checkout/ps-alert/ps-alert-error.html","<md-toast class=\"ps-alert-error\"><span flex=\"\">{{vm.message}}</span><md-button ng-click=\"vm.close()\" class=\"md-warn\">OK</md-button></md-toast>");
$templateCache.put("app/components/ps-checkout/ps-alert/ps-alert-info.html","<md-toast class=\"ps-alert-info\"><span flex=\"\">{{vm.message}}</span><md-button ng-click=\"vm.close()\" class=\"md-warn\">OK</md-button></md-toast>");
$templateCache.put("app/components/ps-checkout/ps-alert/ps-alert-warning.html","<md-toast class=\"ps-alert-warning\"><span flex=\"\">{{vm.message}}</span><md-button ng-click=\"vm.close()\" class=\"md-warn\">OK</md-button></md-toast>");
$templateCache.put("app/components/ps-checkout/ps-alert/ps-alert.html","<div layout=\"column\" flex=\"\"></div>");
$templateCache.put("app/components/ps-checkout/ps-card/ps-card.html","<form name=\"cardForm\" class=\"ps-card\"><div ng-if=\"vm.isLayout([\'default\', \'two-col\', \'one-col\'])\"><ps-card-name></ps-card-name><ps-card-number></ps-card-number><div layout=\"row\"><ps-card-expiry flex=\"55\"></ps-card-expiry><div flex=\"5\"></div><ps-card-verification flex=\"40\"></ps-card-verification></div></div><div ng-if=\"vm.isLayout(\'stacked\')\"><ps-card-name></ps-card-name><ps-card-number></ps-card-number><ps-card-expiry></ps-card-expiry><ps-card-verification></ps-card-verification></div><div ng-if=\"vm.isLayout(\'compact\')\"><div layout=\"row\"><ps-card-name flex=\"65\"></ps-card-name><div flex=\"5\"></div><ps-card-expiry flex=\"30\"></ps-card-expiry></div><div layout=\"row\"><ps-card-number flex=\"70\"></ps-card-number><div flex=\"5\"></div><ps-card-verification flex=\"25\"></ps-card-verification></div></div></form>");
$templateCache.put("app/components/ps-checkout/ps-demo/ps-demo.html","<md-input-container><label>Theme</label><md-select ng-model=\"vm.service.state.theme\"><md-option ng-repeat=\"theme in vm.themes\">{{ theme }}</md-option></md-select></md-input-container><md-input-container><label>Layout</label><md-select ng-model=\"vm.service.state.layout\"><md-option ng-repeat=\"layout in vm.layouts\">{{ layout }}</md-option></md-select></md-input-container><p>Palette</p><md-input-container><label>Primary</label><md-select ng-model=\"vm.service.state.palette.primary\"><md-option ng-repeat=\"color in vm.colors\">{{ color }}</md-option></md-select></md-input-container><md-input-container><label>Accent</label><md-select ng-model=\"vm.service.state.palette.accent\"><md-option ng-repeat=\"color in vm.colors\">{{ color }}</md-option></md-select></md-input-container><md-input-container><label>Warn</label><md-select ng-model=\"vm.service.state.palette.warn\"><md-option ng-repeat=\"color in vm.colors\">{{ color }}</md-option></md-select></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/ps-echeck.html","<form name=\"echeckForm\" class=\"ps-echeck\"><div ng-if=\"vm.service.banksShow\"><ps-echeck-banks></ps-echeck-banks></div><div ng-show=\"vm.service.selectedBankShow\"><ps-echeck-selected></ps-echeck-selected></div></form>");
$templateCache.put("app/components/ps-checkout/ps-invalid/ps-invalid-modal.html","<md-dialog aria-label=\"Invalid\" ng-cloak=\"\"><md-dialog-content class=\"ps-invalid-wrap\"><ps-invalid></ps-invalid></md-dialog-content></md-dialog>");
$templateCache.put("app/components/ps-checkout/ps-invalid/ps-invalid.html","<p>&nbsp;Invalid checkout configuration.&nbsp;</p>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-backwards.html","<ps-logo layout=\"column\"></ps-logo><ps-alert></ps-alert><div layout-gt-xs=\"row\"><div flex=\"\" layout-padding=\"\"><ps-email></ps-email><ps-billing-address></ps-billing-address></div><div flex=\"\" layout-padding=\"\"><md-tabs md-stretch-tabs=\"auto\"><md-tab ng-repeat=\"tab in vm.service.state.features.payment.types\" md-on-select=\"vm.service.state.payment.type = tab.name\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.name}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\"><ps-card ng-switch-when=\"card\"></ps-card><ps-echeck ng-switch-when=\"echeck\"></ps-echeck></div></div></div><ps-pay-button layout=\"column\"></ps-pay-button>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-compact.html","<div ng-hide=\"vm.service.state.checkoutComplete\" class=\"ps-wrap-compact\"><ps-alert></ps-alert><div class=\"ps-custom-logo\"><ps-logo layout=\"column\"></ps-logo></div><div class=\"ps-content\"><div class=\"ps-pay-methods\"><md-tabs md-stretch-tabs=\"auto\" class=\"ps-tabs\"><md-tab ng-repeat=\"tab in vm.service.state.paymentMethods\" md-on-select=\"vm.service.state.payment.type = tab\" ng-disabled=\"tab.disabled\" class=\"ps-tab\"><md-tab-label>{{vm.service.formatTabName(tab)}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-pay-forms\"><ps-card ng-switch-when=\"card\"></ps-card><ps-echeck ng-switch-when=\"echeck\"></ps-echeck></div></div><div class=\"ps-billing-compact\"><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-billing-title\"><div ng-switch-when=\"card\" class=\"ps-billing-title-card\">Billing Information</div><div ng-switch-when=\"echeck\" class=\"ps-billing-title-echeck\">Account Holder Information</div></div><div layout=\"row\"><ps-email flex=\"45\"></ps-email><div flex=\"5\"></div><ps-address-street purpose=\"billing\" flex=\"50\"></ps-address-street></div><div layout=\"row\"><ps-address-city purpose=\"billing\" flex=\"40\"></ps-address-city><div flex=\"5\"></div><ps-address-subdivision purpose=\"billing\" flex=\"55\"></ps-address-subdivision></div><div layout=\"row\"><ps-address-postal purpose=\"billing\" flex=\"40\"></ps-address-postal><div flex=\"5\"></div><ps-address-country purpose=\"billing\" flex=\"55\"></ps-address-country></div></div></div><div ng-if=\"vm.service.showSchedulerInfo()\" class=\"ps-schedule-link\"><i class=\"material-icons\">schedule</i> <a href=\"\" ng-click=\"vm.service.openSchedulerDetails()\">Review Schedule Details</a></div><div class=\"ps-paynow-wrap\"><ps-pay-button layout=\"column\"></ps-pay-button></div><div class=\"ps-powered-logo\"><img ng-src=\"images/paystand-logo-footer.png\" alt=\"Powered byPayStand\"></div></div><div ng-show=\"vm.service.state.checkoutComplete\" class=\"ps-receipt-wrap\"><ps-receipt receipt=\"{{vm.service.checkoutType}}\"></ps-receipt></div>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-mini.html","<ps-alert></ps-alert><div layout-gt-xs=\"row\" layout=\"column\" layout-margin=\"20\" layout-padding=\"20\"><div layout=\"column\" flex=\"\"><md-tabs md-stretch-tabs=\"auto\"><md-tab ng-repeat=\"tab in vm.service.state.features.payment.types\" md-on-select=\"vm.service.state.payment.type = tab.name\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.name}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\"><ps-card ng-switch-when=\"card\" layout=\"column\"></ps-card><ps-echeck ng-switch-when=\"echeck\" layout=\"column\"></ps-echeck></div></div><div layout=\"column\" flex=\"\"><ps-email></ps-email><ps-billing-address flex=\"\"></ps-billing-address></div></div><ps-pay-button layout=\"column\"></ps-pay-button>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-one-col.html","<div ng-hide=\"vm.service.state.checkoutComplete\" class=\"ps-wrap\"><ps-alert></ps-alert><div class=\"ps-custom-logo\"><ps-logo layout=\"column\"></ps-logo></div><div class=\"ps-content\"><div class=\"ps-pay-methods\"><md-tabs md-stretch-tabs=\"auto\" class=\"ps-tabs\"><md-tab ng-repeat=\"tab in vm.service.state.paymentMethods\" md-on-select=\"vm.service.state.payment.type = tab\" ng-disabled=\"tab.disabled\" class=\"ps-tab\"><md-tab-label>{{vm.service.formatTabName(tab)}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-pay-forms\"><ps-card ng-switch-when=\"card\"></ps-card><ps-echeck ng-switch-when=\"echeck\"></ps-echeck></div></div><div class=\"ps-billing\"><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-billing-title\"><div ng-switch-when=\"card\">Billing Information</div><div ng-switch-when=\"echeck\">Account Holder Information</div></div><div class=\"ps-email-wrap\"><ps-email></ps-email></div><div class=\"ps-address-wrap\"><ps-billing-address></ps-billing-address></div></div></div><div ng-if=\"vm.service.showSchedulerInfo()\" class=\"ps-schedule-link\"><i class=\"material-icons\">schedule</i> <a href=\"\" ng-click=\"vm.service.openSchedulerDetails()\">Review Schedule Details</a></div><div class=\"ps-paynow-wrap\"><ps-pay-button layout=\"column\"></ps-pay-button></div><div class=\"ps-powered-logo\"><img ng-src=\"images/paystand-logo-footer.png\" alt=\"Powered byPayStand\"></div></div><div ng-show=\"vm.service.state.checkoutComplete\" class=\"ps-receipt-wrap\"><ps-receipt receipt=\"{{vm.service.checkoutType}}\"></ps-receipt></div>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-stacked.html","<div ng-hide=\"vm.service.state.checkoutComplete\" class=\"ps-wrap\"><ps-alert></ps-alert><div class=\"ps-custom-logo\"><ps-logo layout=\"column\"></ps-logo></div><div class=\"ps-content\"><div class=\"ps-pay-methods\"><md-tabs md-stretch-tabs=\"auto\" class=\"ps-tabs\"><md-tab ng-repeat=\"tab in vm.service.state.paymentMethods\" md-on-select=\"vm.service.state.payment.type = tab\" ng-disabled=\"tab.disabled\" class=\"ps-tab\"><md-tab-label>{{vm.service.formatTabName(tab)}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-pay-forms\"><ps-card ng-switch-when=\"card\"></ps-card><ps-echeck ng-switch-when=\"echeck\"></ps-echeck></div></div><div class=\"ps-billing\"><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-billing-title\"><div ng-switch-when=\"card\" class=\"ps-billing-title-card\">Billing Information</div><div ng-switch-when=\"echeck\" class=\"ps-billing-title-echeck\">Account Holder Information</div></div><div class=\"ps-email-wrap\"><ps-email></ps-email></div><div class=\"ps-address-wrap\"><ps-address-street purpose=\"billing\"></ps-address-street><ps-address-city purpose=\"billing\"></ps-address-city><ps-address-subdivision purpose=\"billing\"></ps-address-subdivision><ps-address-postal purpose=\"billing\"></ps-address-postal><ps-address-country purpose=\"billing\"></ps-address-country></div></div></div><div ng-if=\"vm.service.showSchedulerInfo()\" class=\"ps-schedule-link\"><i class=\"material-icons\">schedule</i> <a href=\"\" ng-click=\"vm.service.openSchedulerDetails()\">Review Schedule Details</a></div><div class=\"ps-paynow-wrap\"><ps-pay-button layout=\"column\"></ps-pay-button></div><div class=\"ps-powered-logo\"><img ng-src=\"images/paystand-logo-footer.png\" alt=\"Powered byPayStand\"></div></div><div ng-show=\"vm.service.state.checkoutComplete\" class=\"ps-receipt-wrap\"><ps-receipt receipt=\"{{vm.service.checkoutType}}\"></ps-receipt></div>");
$templateCache.put("app/components/ps-checkout/ps-layout/ps-layout-two-col.html","<div ng-hide=\"vm.service.state.checkoutComplete\" class=\"ps-wrap\"><ps-alert></ps-alert><div class=\"ps-custom-logo\"><ps-logo layout=\"column\"></ps-logo></div><div layout-gt-xs=\"row\" class=\"ps-content\"><div flex=\"\" class=\"ps-pay-methods\"><md-tabs md-stretch-tabs=\"auto\" class=\"ps-tabs\"><md-tab ng-repeat=\"tab in vm.service.state.paymentMethods\" md-on-select=\"vm.service.state.payment.type = tab\" ng-disabled=\"tab.disabled\" class=\"ps-tab\"><md-tab-label>{{vm.service.formatTabName(tab)}}</md-tab-label></md-tab></md-tabs><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-pay-forms\"><ps-card ng-switch-when=\"card\"></ps-card><ps-echeck ng-switch-when=\"echeck\"></ps-echeck></div></div><div flex=\"\" class=\"ps-billing\"><div ng-switch=\"vm.service.state.payment.type\" class=\"ps-billing-title\"><div ng-switch-when=\"card\">Billing Information</div><div ng-switch-when=\"echeck\">Account Holder Information</div></div><div class=\"ps-email-wrap\"><ps-email></ps-email></div><div class=\"ps-address-wrap\"><ps-billing-address></ps-billing-address></div></div></div><div ng-if=\"vm.service.showScheduledPaymentInfo()\" class=\"ps-schedule-link\"><i class=\"material-icons\">schedule</i> <a href=\"\" ng-click=\"vm.service.openScheduledPaymentDetails()\">Review Schedule Details</a></div><div class=\"ps-paynow-wrap\"><ps-pay-button layout=\"column\"></ps-pay-button></div><div class=\"ps-powered-logo\"><img ng-src=\"images/paystand-logo-footer.png\" alt=\"Powered byPayStand\"></div></div><div ng-show=\"vm.service.state.checkoutComplete\" class=\"ps-receipt-wrap\"><ps-receipt receipt=\"{{vm.service.checkoutType}}\"></ps-receipt></div>");
$templateCache.put("app/components/ps-checkout/ps-logo/ps-logo.html","<img ng-src=\"{{vm.logoUrl}}\" width=\"{{vm.logoWidth}}\" height=\"{{vm.logoHeight}}\">");
$templateCache.put("app/components/ps-checkout/ps-pay-button/ps-pay-button.html","<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.service.getState(\'updateLock\')\"></md-progress-linear><md-button class=\"md-raised ps-paynow\" ps-form=\"psForm\" ng-disabled=\"vm.service.psForm.$invalid || vm.service.psForm.$pending || vm.service.checkoutType ==\'both\' || vm.service.getState(\'updateLock\')\" ng-click=\"vm.pay()\" type=\"submit\"><span ng-switch=\"vm.service.checkoutType\"><span ng-switch-when=\"scheduled\">Schedule Payment(s)</span> <span ng-switch-when=\"both\">PAYMENT CONFIGURATION NOT SUPPORTED</span> <span ng-switch-when=\"tokenize\">Save for Future Payments</span> <span ng-switch-default=\"\">Pay {{vm.state.payment.amount | currency}}</span></span> with <span ng-switch=\"vm.state.payment.type\"><span ng-switch-when=\"card\">Card</span> <span ng-switch-when=\"echeck\">eCheck</span></span></md-button>");
$templateCache.put("app/components/ps-checkout/ps-receipt/ps-receipt.html","<div ng-if=\"vm.isReceiptType(\'payment\')\"><ps-receipt-payment></ps-receipt-payment></div><div ng-if=\"vm.isReceiptType(\'scheduled\')\"><ps-receipt-scheduled-payment></ps-receipt-scheduled-payment></div><div ng-if=\"vm.isReceiptType(\'tokenize\')\"><ps-receipt-token></ps-receipt-token></div>");
$templateCache.put("app/components/ps-checkout/ps-receipt-payment/ps-receipt-payment.html","<h1>Paid</h1><h2>This payment is now settled.</h2><h3>We will send you an email<br>confirmation for your records.</h3><p><br><img ng-src=\"images/paystand-logo-footer.png\" alt=\"PayStand\"></p>");
$templateCache.put("app/components/ps-checkout/ps-receipt-scheduled-payment/ps-receipt-scheduled-payment.html","<h1>Payments Scheduled</h1><h2>This schedule is now active.</h2><h3>We will send you an email<br>confirmation for your records.</h3><p><br><img ng-src=\"images/paystand-logo-footer.png\" alt=\"PayStand\"></p>");
$templateCache.put("app/components/ps-checkout/ps-receipt-token/ps-receipt-token.html","<h1>Saved</h1><h2>This payment method is now saved.</h2><p><br><img ng-src=\"images/paystand-logo-footer.png\" alt=\"PayStand\"></p>");
$templateCache.put("app/components/ps-checkout/ps-scheduled-payment/ps-scheduled-payment.html","<div class=\"ps-scheduled-payment-wrap\"><div class=\"ps-schedule-name\">{{vm.scheduledPayment.name}}</div><div class=\"ps-schedule-description\">{{vm.scheduledPayment.description}}</div><ul><li ng-repeat=\"scheduledPayment in vm.scheduledPayment.scheduledItems track by $index\"><div class=\"ps-routine-name\">{{scheduledPayment.name}}</div><div class=\"ps-routine-description\">{{scheduledPayment.description}}</div><div class=\"ps-routine-overview\"><strong>{{scheduledPayment.schedule.timesToRun || 1}}</strong> payment{{scheduledPayment.schedule.timesToRun ? \'s\' : null}} of {{vm.service.state.currency}} <strong>{{scheduledPayment.amount | currency}}</strong> starting <strong>{{(scheduledPayment.schedule.dateStart | date) || \"today\" }}</strong></div></li></ul></div>");
$templateCache.put("app/components/ps-checkout/ps-address/billing/ps-billing-address.html","<ps-address purpose=\"billing\"></ps-address>");
$templateCache.put("app/components/ps-checkout/ps-address/city/ps-address-city.html","<md-input-container class=\"ps-address-city\" md-no-float=\"\"><input name=\"{{vm.fieldName}}\" ng-model=\"vm.address.city\" required=\"\" md-maxlength=\"100\" minlength=\"2\" autocomplete=\"section-paystand {{vm.purpose}} address-level2\" placeholder=\"City\"><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">City is required.</div><div ng-message=\"md-maxlength\">City is too long.</div><div ng-message=\"minlength\">City should be at least 2 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-address/country/ps-address-country.html","<md-autocomplete placeholder=\"Country\" required=\"true\" md-input-name=\"{{vm.fieldName}}\" md-search-text=\"vm.searchText\" autocomplete=\"section-paystand {{vm.purpose}} country-name\" md-no-cache=\"true\" md-autofocus=\"false\" md-autoselect=\"false\" md-select-on-match=\"true\" md-delay=\"125\" md-selected-item=\"vm.address.country\" md-search-text-change=\"vm.onSearchTextChange(vm.searchText)\" md-selected-item-change=\"vm.onOptionSelected(o)\" md-items=\"o in vm.searchOptions(vm.searchText)\" md-item-text=\"o.name\" md-min-length=\"0\" class=\"ps-address-country\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{o.name}}</span></md-item-template><md-not-found>{{nothingFoundMessage || \"Nothing found\"}}</md-not-found><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">Required.</div><div ng-message=\"md-maxlength\">Too long.</div><div ng-message=\"minlength\">Too short.</div><div ng-message=\"notfound\">Country not found.</div></div></md-autocomplete>");
$templateCache.put("app/components/ps-checkout/ps-address/email/ps-email.html","<md-input-container class=\"ps-email-component\" md-no-float=\"\"><input name=\"{{vm.fieldName}}\" type=\"email\" ng-model=\"vm.service.state.payer.email\" required=\"\" md-maxlength=\"100\" minlength=\"6\" autocomplete=\"section-paystand email\" placeholder=\"Email\"><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">Email is required.</div><div ng-message=\"md-maxlength\">Email is too long.</div><div ng-message=\"minlength\">Email should be at least 6 characters.</div><div ng-message=\"email\">Invalid email address.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-address/postal/ps-address-postal.html","<md-input-container class=\"ps-address-postal\" md-no-float=\"\"><input name=\"{{vm.fieldName}}\" ng-model=\"vm.address.postalCode\" required=\"\" md-maxlength=\"100\" minlength=\"2\" autocomplete=\"section-paystand {{vm.purpose}} postal-code\" placeholder=\"Postal Code\"><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">Required.</div><div ng-message=\"md-maxlength\">Too long.</div><div ng-message=\"minlength\">Too short.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-address/street/ps-address-street.html","<md-input-container class=\"ps-address-street\" md-no-float=\"\"><input name=\"{{vm.fieldName}}\" ng-model=\"vm.address.street\" required=\"\" md-maxlength=\"100\" minlength=\"5\" autocomplete=\"section-paystand {{vm.purpose}} street-address\" placeholder=\"Street Address\"><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">Street is required.</div><div ng-message=\"md-maxlength\">Street is too long.</div><div ng-message=\"minlength\">Street should be at least 5 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-address/subdivision/ps-address-subdivision.html","<md-autocomplete placeholder=\"State\" required=\"true\" md-input-name=\"{{vm.fieldName}}\" md-search-text=\"vm.searchText\" autocomplete=\"section-paystand {{vm.purpose}} address-level1\" md-no-cache=\"true\" md-autofocus=\"false\" md-autoselect=\"false\" md-select-on-match=\"true\" md-delay=\"125\" md-selected-item=\"vm.address.subdivision\" md-search-text-change=\"vm.onSearchTextChange(vm.searchText)\" md-selected-item-change=\"vm.onOptionSelected(o)\" md-items=\"o in vm.searchOptions(vm.searchText)\" md-item-text=\"o.name\" md-min-length=\"0\" class=\"ps-address-state\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{o.name}}</span></md-item-template><md-not-found>{{nothingFoundMessage || \"Nothing found\"}}</md-not-found><div ng-messages=\"vm.service.psForm[vm.fieldName].$error\" ng-show=\"vm.service.psForm[vm.fieldName].$dirty\"><div ng-message=\"required\">Required.</div><div ng-message=\"md-maxlength\">Too long.</div><div ng-message=\"minlength\">Too short.</div><div ng-message=\"notfound\">Not found.</div></div></md-autocomplete>");
$templateCache.put("app/components/ps-checkout/ps-card/expiry/ps-card-expiry.html","<md-input-container class=\"ps-card-expiry\" md-no-float=\"\"><input name=\"card_expiry\" ng-model=\"vm.service.cardExpiry\" type=\"text\" inputmode=\"numeric\" required=\"\" placeholder=\"MM / YY\" autocomplete=\"section-paystand cc-exp\" payments-validate=\"expiry\" payments-format=\"expiry\"><div ng-messages=\"vm.service.cardForm.card_expiry.$error\" ng-show=\"vm.service.cardForm.card_expiry.$dirty\"><div ng-message=\"required\" class=\"md-warn md-hue-3\">Card expiration date is required.</div><div ng-message=\"expiry\" class=\"md-warn md-hue-3\">Invalid expiration date.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-card/name/ps-card-name.html","<md-input-container class=\"ps-oneup ps-card-name\" md-no-float=\"\"><input name=\"card_name\" ng-model=\"vm.service.card.name\" required=\"\" md-maxlength=\"100\" minlength=\"2\" autocomplete=\"section-paystand cc-name\" placeholder=\"Name on Card\"><div ng-messages=\"vm.service.cardForm.card_name.$error\" ng-show=\"vm.service.cardForm.card_name.$dirty\"><div ng-message=\"required\">Name is required.</div><div ng-message=\"md-maxlength\">Name is too long.</div><div ng-message=\"minlength\">Name should be at least 2 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-card/number/ps-card-number.html","<md-input-container class=\"ps-card-number\" md-no-float=\"\"><input name=\"card_number\" ng-model=\"vm.service.card.number\" type=\"text\" inputmode=\"numeric\" required=\"\" ui-mask=\"9999 9999 9999 99?9?9\" ui-mask-placeholder-char=\"space\" ui-mask-placeholder=\"\" autocomplete=\"section-paystand cc-number\" payments-validate=\"card\" payments-type-model=\"vm.service.cardType\" placeholder=\"Card Number\"><div class=\"ps-card-logo\"><span class=\"{{vm.service.cardType | psCardTypeCSSClass}}\"></span></div><div ng-messages=\"vm.service.cardForm.card_number.$error\" ng-show=\"vm.service.cardForm.card_number.$dirty\"><div ng-message=\"required\">Card number is required.</div><div ng-message=\"card\">Invalid card number.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-card/verification/ps-card-verification.html","<md-input-container class=\"ps-card-verification\" md-no-float=\"\"><input name=\"card_verification\" ng-model=\"vm.service.card.securityCode\" type=\"text\" inputmode=\"numeric\" required=\"\" autocomplete=\"section-paystand cc-csc\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"vm.service.cardType\" placeholder=\"Card Verification\"><div ng-messages=\"vm.service.cardForm.card_verification.$error\" ng-show=\"vm.service.cardForm.card_verification.$dirty\"><div ng-message=\"required\">Card verification is required.</div><div ng-message=\"cvc\">Invalid verification.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/accounts/ps-echeck-accounts.html","<form name=\"accountsForm\" class=\"ps-account-content\"><div class=\"ps-account-title\"></div><ps-echeck-accounts-select></ps-echeck-accounts-select><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.service.updateLock\"></md-progress-linear><ps-echeck-accounts-button></ps-echeck-accounts-button></form>");
$templateCache.put("app/components/ps-checkout/ps-echeck/banks/ps-echeck-banks.html","<form name=\"banksForm\"><div ng-show=\"vm.service.banks.selectShow\"><ps-echeck-banks-select></ps-echeck-banks-select></div><div ng-show=\"vm.service.banks.buttonShow\"><ps-echeck-banks-button></ps-echeck-banks-button></div><div ng-show=\"vm.service.banks.logosShow\"><ps-echeck-banks-logos></ps-echeck-banks-logos></div></form>");
$templateCache.put("app/components/ps-checkout/ps-echeck/login/ps-echeck-login.html","<form name=\"loginForm\" class=\"ps-login-content\"><div class=\"ps-login-title\"></div><div ng-if=\"vm.service.banks.selectedBank.required.username\"><ps-echeck-login-username></ps-echeck-login-username></div><div ng-if=\"vm.service.banks.selectedBank.required.password\"><ps-echeck-login-password></ps-echeck-login-password></div><div ng-if=\"vm.service.banks.selectedBank.required.pin\"><ps-echeck-login-pin></ps-echeck-login-pin></div><div class=\"ps-signin-progress\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.service.updateLock\"></md-progress-linear></div><ps-echeck-login-button></ps-echeck-login-button></form>");
$templateCache.put("app/components/ps-checkout/ps-echeck/mfa/ps-echeck-mfa.html","<form name=\"mfaForm\" class=\"ps-mfa-content\"><div class=\"ps-mfa-title\"></div><div ng-repeat=\"challenge in vm.service.mfa.challenges track by $index\"><div ng-switch=\"challenge.challengeType\"><div ng-switch-when=\"device\"><ps-echeck-mfa-device challenge-index=\"{{$index}}\"></ps-echeck-mfa-device></div><div ng-switch-when=\"questions\"><ps-echeck-mfa-questions challenge-index=\"{{$index}}\"></ps-echeck-mfa-questions></div><div ng-switch-when=\"selections\"><ps-echeck-mfa-selections challenge-index=\"{{$index}}\"></ps-echeck-mfa-selections></div></div></div><div class=\"ps-signin-progress\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.service.updateLock\"></md-progress-linear></div><ps-echeck-mfa-button></ps-echeck-mfa-button></form>");
$templateCache.put("app/components/ps-checkout/ps-echeck/selected/ps-echeck-selected.html","<div class=\"ps-selected-bank-title\">Selected Bank &nbsp; <a href=\"\" ng-click=\"vm.service.resetEcheck()\">change bank</a></div><div class=\"ps-selected-bank-wrap\"><div class=\"selected-bank-logo {{vm.service.banks.selectedBank.bankKey}}-confirm-bkg\"><div class=\"selected-bank-logo {{vm.service.banks.selectedBank.bankKey}}-confirm\"><div ng-if=\"vm.noLogo()\" class=\"longtail-confirm-bkg\"><div class=\"longtail-confirm\">{{vm.service.banks.selectedBank.bankName}}</div></div></div></div><div class=\"ps-selected-bank-content\"><div class=\"ps-selected-bank-name\">{{vm.service.accounts.token.nameOnAccount}}</div><div class=\"ps-selected-bank-account\">{{vm.service.accounts.token.accountHolderType | psStartCase}} {{vm.service.accounts.token.accountType | psStartCase}} ({{vm.service.accounts.token.last4}})<br></div><div class=\"ps-selected-bank-balance\">{{vm.service.accounts.token.availableBalance | currency}}</div></div><input ng-model=\"vm.bank\" disabled=\"true\" required=\"true\" type=\"hidden\"></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/wizard/ps-echeck-wizard-modal.html","<md-dialog aria-label=\"Bank Login\" ng-cloak=\"\"><md-dialog-content class=\"ps-bank-modal-wrap\"><ps-echeck-wizard></ps-echeck-wizard></md-dialog-content></md-dialog>");
$templateCache.put("app/components/ps-checkout/ps-echeck/wizard/ps-echeck-wizard.html","<div class=\"ps-bank-modal-title {{vm.service.banks.selectedBank.bankKey}}-signin-bkg\"><div class=\"{{vm.service.banks.selectedBank.bankKey}}-signin\"><i class=\"material-icons\" ng-click=\"vm.service.banks.closeLogin()\">clear</i><div ng-if=\"vm.noLogo()\" class=\"longtail-signin-bkg\"><div class=\"longtail-signin\">{{vm.service.banks.selectedBank.bankName}}</div></div></div></div><div class=\"ps-bank-modal-content\"><div ng-if=\"vm.service.wizard.loginShow\"><ps-echeck-login></ps-echeck-login></div><div ng-if=\"vm.service.wizard.mfaShow\"><ps-echeck-mfa></ps-echeck-mfa></div><div ng-if=\"vm.service.wizard.accountsShow\"><ps-echeck-accounts></ps-echeck-accounts></div></div>");
$templateCache.put("app/components/ps-checkout/ps-scheduled-payment/wizard/ps-scheduled-payment-wizard-modal.html","<md-dialog aria-label=\"Scheduled Payment\" ng-cloak=\"\"><md-dialog-content class=\"ps-scheduled-payment-modal-wrap\"><ps-scheduled-payment-wizard></ps-scheduled-payment-wizard></md-dialog-content></md-dialog>");
$templateCache.put("app/components/ps-checkout/ps-scheduled-payment/wizard/ps-scheduled-payment-wizard.html","<md-toolbar style=\"position:fixed;\"><div class=\"md-toolbar-tools\"><h2>Schedule Information</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.service.closeScheduledPaymentDetails()\"><i class=\"material-icons\">close</i></md-button></div></md-toolbar><br><br><ps-scheduled-payment></ps-scheduled-payment>");
$templateCache.put("app/components/ps-checkout/ps-echeck/accounts/button/ps-echeck-accounts-button.html","<div class=\"ps-bank-modal-btn {{vm.service.banks.selectedBank.bankKey}}-btn\"><md-button class=\"md-raised\" ng-click=\"vm.service.accounts.selectAccount()\" ng-disabled=\"vm.service.accounts.accountsForm.$invalid || vm.service.accounts.accountsForm.$pending\" type=\"submit\">Select</md-button></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/accounts/select/ps-echeck-accounts-select.html","<md-radio-group required=\"true\" name=\"accounts_token\" ng-model=\"vm.service.accounts.token\" class=\"md-primary\"><md-radio-button ng-repeat=\"token in vm.service.accounts.tokens\" ng-value=\"token\" ng-disabled=\"token.bank.invalid\"><div ng-show=\"token.bank.insufficientFunds\">Insufficient Funds</div><div ng-show=\"token.bank.currencyDoesNotMatch\">Bank currency does not match payment currency</div><div class=\"ps-account-wrap\"><span class=\"ps-account-name\">{{token.accountName | psStartCase}}</span><br><span class=\"ps-account-type\">{{token.accountType | psStartCase}}</span> <span class=\"ps-account-number\">({{token.last4}})</span><br><span class=\"ps-account-currency\">{{token.currency}}</span> - <span class=\"ps-account-balance\">{{token.availableBalance | currency}}</span></div></md-radio-button><div ng-messages=\"vm.service.accounts.accountsForm.accounts_token.$error\" ng-show=\"vm.service.accounts.accountsForms.accounts_token.$dirty\"><div ng-message=\"required\">Required.</div></div></md-radio-group>");
$templateCache.put("app/components/ps-checkout/ps-echeck/banks/button/ps-echeck-banks-button.html","<div ng-show=\"vm.service.banks.showSelectButton\"><md-button class=\"md-raised ps-bank-select-btn\" ng-disabled=\"\" ng-click=\"vm.service.banks.selectBank()\" type=\"submit\" md-autofocus=\"\">{{vm.service.banks.buttonText}}</md-button></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/banks/logos/ps-echeck-banks-logos.html","<div class=\"ps-bank-links-wrap\"><div class=\"ps-bank-links\"><div ng-repeat=\"bank in vm.service.banks.bankList\"><div ng-click=\"vm.service.banks.selectBank(bank)\" class=\"ps-bank-link {{bank.bankKey}}-link-bkg\"><md-tooltip md-direction=\"bottom\">{{bank.bankName}}</md-tooltip><div class=\"{{bank.bankKey}}-link\"></div></div></div><div style=\"clear: both;\"></div></div></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/banks/select/ps-echeck-banks-select.html","<md-autocomplete required=\"true\" placeholder=\"Search Banks\" md-input-name=\"search_banks\" md-search-text=\"vm.service.banks.searchText\" autocomplete=\"section-paystand search-banks\" md-no-cache=\"true\" md-autoselect=\"false\" md-select-on-match=\"true\" md-delay=\"125\" md-selected-item=\"vm.service.banks.selectedSearchBank\" md-selected-item-change=\"vm.service.banks.setSelectedBank(bank)\" md-items=\"bank in vm.service.banks.searchBanks()\" md-item-text=\"bank.bankName\" md-min-length=\"0\" class=\"ps-banks-select\"><md-item-template><span md-highlight-text=\"vm.service.banks.searchText\">{{bank.bankName}}</span></md-item-template><md-not-found>{{nothingFoundMessage || \"Nothing found\"}}</md-not-found></md-autocomplete><div ng-messages=\"vm.service.banks.banksForm.search_banks.$error\" ng-show=\"vm.service.banks.banksForm.search_banks.$dirty\"><div ng-message=\"required\" class=\"ps-autocomplete-error\">Bank is required.</div><div ng-message=\"md-maxlength\" class=\"ps-autocomplete-error\">Too long.</div><div ng-message=\"minlength\" class=\"ps-autocomplete-error\">Too short.</div><div ng-message=\"notfound\" class=\"ps-autocomplete-error\">Bank not found.</div></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/login/button/ps-echeck-login-button.html","<div class=\"ps-bank-modal-btn {{vm.service.banks.selectedBank.bankKey}}-btn\"><md-button class=\"md-raised\" ng-disabled=\"vm.service.login.loginForm.$invalid || vm.service.login.loginForm.$pending || vm.service.updateLock\" ng-click=\"vm.service.login.login()\" type=\"submit\">Login</md-button></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/login/password/ps-echeck-login-password.html","<md-input-container class=\"ps-login-password\" md-no-float=\"\"><input name=\"password\" type=\"password\" ng-model=\"vm.service.login.password\" required=\"\" md-maxlength=\"100\" minlength=\"0\" autocomplete=\"section-paystand password\" placeholder=\"Password\"><div ng-messages=\"vm.service.login.loginForm.password.$error\" ng-show=\"vm.service.login.loginForm.password.$dirty\"><div ng-message=\"required\">Password is required.</div><div ng-message=\"md-maxlength\">Password is too long.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/login/pin/ps-echeck-login-pin.html","<md-input-container class=\"ps-login-pin\" md-no-float=\"\"><input name=\"pin\" ng-model=\"vm.service.login.pin\" required=\"\" md-maxlength=\"100\" minlength=\"3\" autocomplete=\"section-paystand {{vm.purpose}} street-address\" placeholder=\"Pin\"><div ng-messages=\"vm.service.login.loginForm.$error\" ng-show=\"vm.service.login.loginForm.$dirty\"><div ng-message=\"required\">Pin is required.</div><div ng-message=\"md-maxlength\">Pin is too long.</div><div ng-message=\"minlength\">Pin should be at least 3 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/login/username/ps-echeck-login-username.html","<md-input-container class=\"ps-login-username\" md-no-float=\"\"><input name=\"username\" ng-model=\"vm.service.login.username\" required=\"\" md-maxlength=\"100\" minlength=\"0\" autocomplete=\"section-paystand username\" md-autofocus=\"\" placeholder=\"Username\"><div ng-messages=\"vm.service.login.loginForm.username.$error\" ng-show=\"vm.service.login.loginForm.username.$dirty\"><div ng-message=\"required\">Username is required.</div><div ng-message=\"md-maxlength\">Username is too long.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/mfa/button/ps-echeck-mfa-button.html","<div class=\"ps-bank-modal-btn {{vm.service.banks.selectedBank.bankKey}}-btn\"><md-button class=\"md-raised\" ng-disabled=\"vm.service.mfa.mfaForm.$invalid || vm.service.mfa.mfaForm.$pending || vm.service.updateLock\" ng-click=\"vm.service.mfa.submitMfa()\" type=\"submit\">Submit</md-button></div>");
$templateCache.put("app/components/ps-checkout/ps-echeck/mfa/device/ps-echeck-mfa-device.html","<md-input-container class=\"ps-mfa-device\"><label>{{vm.service.mfa.challenges[vm.challengeIndex].question}}</label> <input name=\"mfa_challenge_{{vm.challengeIndex}}\" ng-model=\"vm.service.mfa.answers[vm.challengeIndex]\" required=\"\" md-maxlength=\"100\" minlength=\"1\" autocomplete=\"section-paystand mfa device\" autofocus=\"autofocus\"><div ng-messages=\"vm.service.mfa.mfaForm[\'mfa_challenge_\' + vm.challengeIndex].$error\" ng-show=\"vm.service.mfa.mfaForm[\'mfa_challenge_\' + vm.challengeIndex].$dirty\"><div ng-message=\"required\">Code is required.</div><div ng-message=\"md-maxlength\">Code is too long.</div><div ng-message=\"minlength\">Code should be at least 1 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/mfa/questions/ps-echeck-mfa-questions.html","<md-input-container class=\"ps-mfa-question\" md-no-float=\"\"><input name=\"mfa_challenge_{{vm.challengeIndex}}\" ng-model=\"vm.service.mfa.answers[vm.challengeIndex]\" required=\"\" md-maxlength=\"100\" minlength=\"1\" autocomplete=\"section-paystand mfa device\" autofocus=\"autofocus\" placeholder=\"{{vm.service.mfa.challenges[vm.challengeIndex].question}}\"><div ng-messages=\"vm.service.mfa.mfaForm[\'mfa_challenge_\' + vm.challengeIndex].$error\" ng-show=\"vm.service.mfa.mfaForm[\'mfa_challenge_\' + vm.challengeIndex].$dirty\"><div ng-message=\"required\">Answer is required.</div><div ng-message=\"md-maxlength\">Answer is too long.</div><div ng-message=\"minlength\">Answer should be at least 1 characters.</div></div></md-input-container>");
$templateCache.put("app/components/ps-checkout/ps-echeck/mfa/selections/ps-echeck-mfa-selections.html","<md-input-container class=\"ps-mfa-selections\" md-no-float=\"\"><md-select required=\"true\" name=\"mfa_challenge_{{vm.challengeIndex}}\" ng-model=\"vm.service.mfa.answers[vm.challengeIndex]\" placeholder=\"{{vm.service.mfa.challenges[vm.challengeIndex].question}}\"><md-option ng-repeat=\"option in vm.service.mfa.challenges[vm.challengeIndex].answers\" value=\"{{option}}\" autofocus=\"autofocus\">{{option}}</md-option></md-select><div ng-messages=\"vm.service.mfa.mfaForm[\'mfa_challenge_\' + vm.challengeIndex].$error\" ng-show=\"vm.service.mfa[\'mfa_challenge_\' + vm.challengeIndex].$dirty\"><div ng-message=\"required\">Answer is required.</div></div></md-input-container>");}]);